// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 12px;
}

.paginationExtends {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.breadcrumb {
    padding-bottom: 20px;
}

.btnAdd {
    float: right;
    width: 200px;
}

.dropDown {
    width: 100%;
}

.inlineInput {
    display: inline;
}

.actionButton {
    float: right;
}

.btnDetails {
    float: right;
}

.btnAction {
    width: 180px;
}

.btnActionHidden {
    display: none;
}

.headerCenter {
    text-align: center;
}

.supplier_detail {
    margin-top: 10px;
}

.fob article .list_content_action {
    /* display: flex; */
    /* margin-bottom: 10px !important; */
}

.my-group-row {
    background-color: #0a7c76;
    font-weight: bold;
    padding: 5px;
}

/* Target group rows (assuming group data has a 'group' property) */
.ant-btn-primary {
    /* background-color: #1e5f85; */
    box-shadow: none;
}

.so-column-setting {
    width: 200px;
    min-height: fit-content;
    height: auto;
}

.article-column-setting {
    width: 200px;
    min-height: fit-content;
    height: auto;
}

.supplier-column-setting {
    width: 200px;
    min-height: fit-content;
    height: auto;
}

.column-setting {
    width: 200px;
    min-height: fit-content;
    height: auto;
}

.labelCenter .ant-form-item-label {
    text-align: center !important;
}

.labelCenter .ant-form-item-control-input-content {
    display: flex;
    justify-content: center;
}

/* SO style photo upload cards */
.so-style-photo-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
}

.so-style-photo-upload__cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}

.so-style-photo-card.ant-form-item {
    margin-bottom: 0;
    width: 168px;
}

.so-style-photo-card__shell {
    width: 168px;
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 2px 8px rgba(15, 35, 80, 0.06);
}

.so-style-photo-card__body {
    background: var(--so-photo-primary-bg, #eef4ff);
}

.so-style-photo-card__body .ant-upload-wrapper {
    display: block;
}

.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list {
    display: block;
}

.so-style-photo-card__body .ant-upload-wrapper .ant-upload-select,
.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item-container {
    width: 168px !important;
    height: 148px !important;
    margin: 0 !important;
}

.so-style-photo-card__body .ant-upload-wrapper .ant-upload-select {
    background: var(--so-photo-primary-bg, #eef4ff) !important;
    border: 1.5px dashed var(--so-photo-primary-border, var(--so-photo-primary, #3349b3)) !important;
    border-bottom: none !important;
    border-radius: 16px 16px 0 0 !important;
}

.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item-container {
    border-radius: 16px 16px 0 0 !important;
    overflow: hidden;
}

.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item {
    padding: 0 !important;
    border: 1.5px dashed var(--so-photo-primary-border, var(--so-photo-primary, #3349b3)) !important;
    border-bottom: none !important;
    border-radius: 16px 16px 0 0 !important;
}

.so-style-photo-card__trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 100%;
    color: var(--so-photo-primary, #3349b3);
}

.so-style-photo-card__trigger-icon {
    font-size: 28px;
    color: var(--so-photo-primary, #3349b3);
}

.so-style-photo-card__trigger-text {
    font-size: 13px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.45);
    line-height: 1.2;
}

.so-style-photo-card__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    padding: 8px 10px;
    background: var(--so-photo-primary, #3349b3);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    line-height: 1.3;
}

.so-style-photo-upload__note {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 260px;
    max-width: 100%;
    padding: 10px 28px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 4px 12px rgba(15, 35, 80, 0.08);
    color: rgba(0, 0, 0, 0.55);
    font-size: 13px;
    font-weight: 500;
    text-align: center;
}

.so-style-photo-card .ant-form-item-explain {
    text-align: center;
    margin-top: 6px;
}

/* table supplier */
#tblSupplierList .ant-table-thead th {
    text-align: center;
}

/* table article */
#tbNPL .ant-table-thead th {
    text-align: center;
}

/* table master file */
#tblMF .ant-table-thead th {
    text-align: center;
}

/* table invoice */
#tblSO .ant-table-thead th {
    text-align: center;
}

/* table BOM */
#tblBOM .ant-table-thead th {
    text-align: center;
}

#table .ant-table-thead th {
    text-align: center;
}

/* column setting for table SO,MF, Category */
/* #column_setting .ant-form-item-control-input {
    min-height:fit-content;
} */
form#column_setting.ant-form-small .ant-form-item .ant-form-item-control-input {
    min-height: fit-content !important;
}

.ant-btn .ant-space.ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small:not(.actionButton) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* .ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
} */
body[data-theme='dark'] .ant-menu-item-selected,
body[data-theme='dark'] .ant-menu .ant-menu-item-selected {
    background-color: #2f4060;
}

body[data-theme='dark'] .ant-select-tree-node-selected,
body[data-theme='dark'] .ant-tree-select-dropdown .ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
    background-color: #2f4060;
}


body[data-theme='dark'] .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected>.ant-table-cell {
    background: #2f4060;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
    display: inline;
    text-align: right;
    width: 100%;
}

/* input[type='text'] {
    display: inline-block;
    text-align: right;
} */
.modal_container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner_modal {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        width: 300px;
        height: 200px;
        border-radius: 6px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
        background-color: #ffffff;

        .modal_body {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 65%;
            padding: 10px;
        }

        .modal_foot {
            display: flex;
            justify-content: center;
            align-items: center;

            button {
                padding: 10px;
                margin: 0 5px;
            }
        }
    }

    .btn_close {
        position: absolute;
        right: 0;
        top: 0;
        padding: 10px;
    }
}

.guard_btn {
    font-size: 16px;
    padding: 10px 20px;
    height: 50px;
    background-color: #222;
    color: #b4bed2;
    border: none;
}

.dragHandler:hover {
    cursor: move;
    /* background-color: #ccc;
    transition: 0.3s; */
}

body[data-theme='dark'] .dragHandler:hover {
    cursor: move;
    /* background-color: #2f4060;
    transition: 0.3s; */
}

.dragHandler {
    transition: 0.3s;
}

.react-resizable {
    position: relative;
    background-clip: padding-box;
}

.react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 100%;
    bottom: 0;
    right: -10px;
    cursor: col-resize;
    z-index: 1;
}

@media (max-width: 576px) {
    .ant-picker-panels {
        flex-direction: column;
    }
}

.tblChart table {
    font-size: small;
}

.ant-form-item-required {
    flex-direction: row-reverse;
}

.ant-form-item-required::before {
    margin-left: 4px;
}

.ant-form-item-required::after {
    width: 0;
    margin: 0 !important;
}

th:has(.dragHandler) {
    padding: 0px 8px !important;
}

.searchSpace> :first-child {
    width: 100%;
    overflow: hidden;
}

.pointer-cursor {
    cursor: pointer;
}

.fullscreen-light table-wrapper,
.fullscreen-dark table-wrapper {
    min-height: 100vh;
    margin-top: 0;
}

/* .fullscreen .table-wrapper,
.fullscreen-light .table-wrapper,
.fullscreen-dark .table-wrapper {
    min-height: 100vh;
    margin-top: 0;
}

.fullscreen > *:first_child,
.fullscreen-light > *:first_child,
.fullscreen-dark > *:first_child {
    min-height: 100vh;
    margin-top: 0;
} */
.ant-form-item {
    margin-bottom: 10px;
}

.hidden-dot {
    list-style-type: none;
    margin-top: 10px;
}

.read.light {
    background-color: #eee;
}

.read.light:hover {
    background-color: white;
    transition: 0.3s;
}

.read.dark {
    background-color: #1b2531;
}

.read.dark:hover {
    background-color: #283142;
    transition: 0.3s;
}

.bold {
    font-weight: bold !important;
}

/* Sửa lỗi font */
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: unset;
    font-weight: bold !important;
}



/* Sửa lỗi font */
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: unset;
    font-weight: bold !important;
}

.checkbox-disabled {
    background-color: red !important;
}

/* .ant-table-thead .ant-table-cell {
    background-color: #1e5f85 !important;
    color: white !important
} */

.ant-table-cell-fix-left {
    overflow-wrap: unset !important;
}

.small .ant-table-cell {
    padding: 5px !important;
    font-size: 0.7rem !important;
}

.small .ant-select-selector {
    font-size: 0.7rem !important;
}

.ant-table-header {
    text-transform: uppercase;
}

.fullscreen-action-dark {
    position: fixed;
    /* z-index: 2000; */
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 12px;
    min-height: 100vh;
    margin-top: 0;
    background-color: #1b2531;
    overflow: auto;
    box-sizing: border-box;
}

.fullscreen-action-light {
    position: fixed;
    /* z-index: 2000; */
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 12px;
    min-height: 100vh;
    margin-top: 0;
    background-color: #ffffff;
    overflow: auto;
    box-sizing: border-box;
}

/* Khi vẫn còn nested trong card có stacking context — nâng card lên trên side-nav */
.ant-main-card:has(.fullscreen-action-light),
.ant-main-card:has(.fullscreen-action-dark) {
    /* z-index: 2000 !important; */
    position: relative;
}

/* Modal / Drawer overlay — luôn trên side-nav (999) + module menu rail (1000) + header */
#nagaco-overlay-root,
#bom-modal-root {
    position: relative;
    z-index: 5000;
}

/* .nagaco-modal-above-layout.ant-modal-root,
.nagaco-modal-above-layout .ant-modal-mask,
.nagaco-modal-above-layout .ant-modal-wrap {
    z-index: 1000 !important;
} */

/* TreeTable.css */
.parent-row-light {
    font-weight: bold;
    background-color: #fafafa;
}

.parent-row-dark {
    font-weight: bold;
    /* background-color: #1b2531; */
}

th.ant-descriptions-item-label {
    width: 180px;
}

.react-json-view textarea {
    resize: both
}

.ant-table-thead {
    th {
        text-transform: uppercase;
        text-align: center !important;
    }
}

.nav-item_flex {
    display: flex;
    width: 100%;
}

.nav-item_title {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1;
    display: block;
}

.board-column {
    min-width: 250px !important;

}

.orangzition_unit-row {
    font-weight: 600;
    padding-bottom: 10px;
    color: #0a7c76 !important;
}

/* Chỉ áp dụng cho class cụ thể */
.custom-height-select .ant-select-selector {
    height: 35px !important;
    align-items: center;
    /* căn giữa text */
    width: 450px !important;
}

.ant-select-multiple .ant-select-selector {
    min-height: 36px;
    /* chỉnh theo chiều cao bạn muốn */
    display: flex;
    align-items: center;
    /* Căn giữa theo chiều dọc */
    padding: 4px 8px;
}

.auto-width {
    width: auto !important;
    height: auto !important;
    padding: 0px !important;
}

.ant-full-width {
    width: 100%;
}

.ant-field-with-button,
.ant-field-with-button .ant-select-selector {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right-width: 0px !important;
}

.ant-merge-field {
    display: flex !important;
    width: 100%;
}

/* Space.Compact: vạch ngăn giữa các nút primary — trắng, chỉ giữa các nút (không ở đầu) */
.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(:disabled)::before,
.nagaco-primary-compact .ant-btn-compact-item.ant-btn-primary:not(:disabled)+.ant-btn-compact-item.ant-btn-primary:not(:disabled)::before {
    position: absolute;
    top: -1px;
    inset-inline-start: -1px;
    display: inline-block;
    width: 1px;
    height: calc(100% + 2px);
    background-color: var(--nagaco-compact-divider-color, #ffffff) !important;
    content: '' !important;
    pointer-events: none;
    z-index: 1;
}

/* Không bao giờ vẽ vạch ở nút đầu tiên */
.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item.ant-btn-compact-first-item::before,
.nagaco-primary-compact .ant-btn.ant-btn-primary.ant-btn-compact-item.ant-btn-compact-first-item::before {
    display: none !important;
    content: none !important;
    width: 0 !important;
}

/* Fallback border phải giữa các nút (không đụng cạnh trái) */
.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(:disabled) {
    border-inline-end-color: var(--nagaco-compact-divider-color, #ffffff) !important;
}

.ant-merge-field>.ant-space-compact-item:first-child,
.ant-merge-field>div:first-child {
    flex: 1 1;
    min-width: 0;
}

.ant-merge-field .ant-select {
    width: 100%;
}

.ant-merge-field .ant-prefix-button {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.ant-merge-field:not(:hover) .ant-select-selector,
.ant-merge-field:not(:hover) .ant-input,
.ant-merge-field:not(:hover) .ant-input-affix-wrapper {
    border-color: var(--nagaco-merge-field-border-color, var(--ant-color-border, #d9d9d9)) !important;
}

.ant-merge-field .ant-prefix-button:not(:disabled) {
    border-color: var(--nagaco-merge-field-button-border-color, transparent) !important;
    box-shadow: none !important;
}

/* Space.Compact + select: không vạch giữa combobox và nút + (mặc định transparent) */
.ant-merge-field.ant-space-compact .ant-prefix-button.ant-btn-compact-item:not(.ant-btn-compact-first-item)::before {
    display: none !important;
    content: none !important;
    width: 0 !important;
}

.ant-merge-field.ant-space-compact .ant-prefix-button.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(:disabled) {
    border-inline-start-color: var(--nagaco-merge-field-button-border-color, transparent) !important;
}

.ant-prefix-button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    /* border: solid 1px var(--ant-color-border, #4e5b74); */
    border-left-width: 0px !important;
}

.ant-form-item-has-error .ant-prefix-button {
    border-color: #ff6b72 !important;
}

.ant-form-item-has-error:hover .ant-prefix-button {
    border-color: #ff9496 !important;
}

.ant-select-selector {
    box-shadow: none !important;
}

.ant-form-small .ant-merge-field .ant-prefix-button {
    height: auto;
}

.ant-form-small .ant-prefix-button {
    height: 30px;
}

.ant-form-large .ant-prefix-button {
    height: 48px;
}

.ant-form .ant-steps-item-title {
    font-size: 14px;
}

.ant-merge-field:hover .ant-select-selector,
.ant-merge-field:hover .ant-input,
.ant-merge-field:hover .ant-input-affix-wrapper {
    border-color: var(--nagaco-merge-field-hover-border, var(--ant-color-primary-border, #6e9cfb)) !important;
}

.ant-merge-field:hover .ant-prefix-button:not(:disabled) {
    border-color: var(--nagaco-merge-field-button-border-color, transparent) !important;
}

.ant-translate-tag {
    margin: 0px;
    padding: 0px;
    list-style-type: none;
    display: flex;
    margin-bottom: 5px;
}

.ant-translate-tag .ant-tag {
    margin-right: 5px;
}

.ant-translate-tag li {
    margin-right: 20px
}

.ant-dock-pannel {
    position: absolute;
    z-index: 100;
    right: 0;
    top: 0;
    height: calc(100% - 33px) !important;
    margin-top: 34px !important;
    background-color: #283142;
    transition: all linear 0.5s;
    /* box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2); */
    padding: 20px;
    overflow-y: auto;
    /* overflow-x: hidden; */
    border-left: 1px solid rgb(77, 91, 117);
    scrollbar-width: none;
}

body[data-theme='light'] .ant-dock-pannel {
    background-color: #ffffff !important;
    border-color: #e6ebf1;
    /* box-shadow: -4px 0px 8px rgba(32, 32, 33, 0.2); */
    /* border-color: #f0f0f0 !important; */
}

.ant-dock-pannel.expand .ant-btn-group .ant-btn {
    box-shadow: -5px 5px 8px rgba(76, 78, 100, 0.2);
    color: #699dff;
    border-color: #699dff;
}

.ant-dock-pannel.minimize {
    width: 0px;
}

.ant-dock-pannel.minimize.hovered .ant-btn-group,
.ant-dock-pannel.expand .ant-btn-group {
    transition: all 0.45s linear 0.05s;
}

.hover-mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 120, 255, 0.1);
    pointer-events: none;
}

.ant-dock-pannel .ant-btn-group {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding: 0px;
    z-index: 110;
    position: fixed;
    top: 48vh;
    transform: translateY(-50%);
    right: 33px;
    /* border-top-left-radius: 10px; */
    /* border-bottom-left-radius: 10px; */
    /* border: 1px solid #1c232f; */
    /* border-right-width: 0px !important; */
    transition: all linear 0.45s;
    /* background-color: #1e5f85; */
    /* box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2); */
}

.ant-dock-pannel .ant-btn-group button {
    box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2);
}

body[data-theme='light'] .ant-btn-group {
    /* background-color: #ffffff !important; */
    /* border-color: #f0f0f0 !important; */
}

.ant-dock-pannel.hovered,
.ant-dock-pannel.expand {
    width: 400px;
    /* margin-left: 20px; */
}

.ant-dock-pannel .ant-dock-content {
    display: none;
    overflow: hidden;
    height: calc(100% - 34px) !important;
    overflow-y: scroll;
    /* margin-top: 34px ! important; */
}

.ant-dock-pannel.hovered .ant-dock-content,
.ant-dock-pannel.expand .ant-dock-content {
    display: block;
    /* margin-left: 20px; */
    height: calc(100% - 34px) !important;
    /* margin-top: 34px ! important; */
}

.ant-dock-pannel.hovered .ant-btn-group,
.ant-dock-pannel.expand .ant-btn-group {
    right: 392px;
}

/* Inline dock: đặt SAU các rule absolute/fixed để thắng specificity */
.ant-dock-pannel.ant-dock-pannel--inline {
    position: relative !important;
    right: auto !important;
    top: auto !important;
    height: auto !important;
    align-self: stretch;
    flex-shrink: 0;
    min-height: 200px;
    margin-left: 16px;
}

.ant-dock-pannel.ant-dock-pannel--inline.minimize {
    width: 24px !important;
    min-width: 24px;
    padding: 0 !important;
    overflow: visible;
    background: transparent !important;
    border-left: none !important;
}

.ant-dock-pannel.ant-dock-pannel--inline .ant-btn-group,
.ant-dock-pannel.ant-dock-pannel--inline.minimize .ant-btn-group,
.ant-dock-pannel.ant-dock-pannel--inline.expand .ant-btn-group,
.ant-dock-pannel.ant-dock-pannel--inline.hovered .ant-btn-group {
    position: absolute !important;
    right: auto !important;
    left: 0 !important;
    top: 48% !important;
    transform: translateY(-50%);
}

.ant-btn-group .break::after {
    content: "";
    display: block;
    /* width: 45px; */
    height: 1px;
    background-color: #4d5b75;
}

.ant-btn-group button {
    height: 50px;
}

/* 
body[data-theme='light'] .ant-btn-group .break::after {
    
    background-color: #1e5f85;
} */

.timeline-approval-history .ant-timeline.ant-timeline-label .ant-timeline-item-label {
    position: unset;
}

.timeline-approval-history .ant-timeline .ant-timeline-item-content {
    margin-top: -40px;
}

.timeline-approval-history .ant-timeline.ant-timeline-label .ant-timeline-item-head {
    top: 10px;
}

.ant-select-selection-overflow-item {
    margin-right: 10px
}

.ant-descriptions-collapse {
    max-height: 1000px;
    overflow-y: auto;
    transition: all 0.5s ease;
}

.ant-descriptions-collapse.ant-descriptions-hidden {
    overflow: hidden;
    max-height: 0px
}

.ant-fullwidth {
    width: 100%;
}

.ant-fullheight {
    height: 100%;
}

.ant-input-number-sm .ant-input-number-input {
    height: 30px !important;
}

#form_filter .ant-form-item {
    margin-bottom: 4px !important;
}

.ant-btn-color-dangerous {
    box-shadow: unset;
}

.dashboard-item {
    /* border-radius: 10px; */
    background-color: #fbfcfc;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity linear 0.5s;
    position: relative;
    overflow: hidden;
}

.dashboard-item .dashboard-add {
    opacity: 0.1;
    transition: opacity linear 0.5s;
    font-size: 16
}

.dashboard-item:hover .dashboard-add {
    opacity: 0.8;
}

.dashboard-item:hover {
    background-color: #f4f5f5;
}

body[data-theme='dark'] .dashboard-item,
body[data-theme='dark'] .screen .screen-header {
    background-color: #2b3445;
    border-color: #1c232f;
}

body[data-theme='dark'] .screen {
    background-color: #283142;
    border-color: #1c232f;
}

body[data-theme='dark'] .dashboard-item:hover {
    background-color: #30394b;
}

body[data-theme='dark'] .text-muted-foreground {
    color: #8892a4
}

.screen {
    border-radius: 10px;
    border: 1px solid #b4b4b5;
    background: #fbfcfc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 8px 32px rgba(0, 0, 0, 0.06),
}

.flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.screen .screen-header {
    height: 38px;
    border-bottom: solid 1px #b4b4b5;
    background: #f4f5f5;
    padding: 0px 16px
}

.screen .screen-header .screen-header__dot {
    width: 8px;
    height: 8px;
    border-radius: 8px;
}

.text-muted-foreground {
    line-height: normal;
    color: #6b7280;
}

.overflow-auto {
    overflow: auto;
}

.flex-center {
    justify-content: center;
    align-items: center;
    display: flex;
}

.action-pannel {
    width: 250px;
    height: calc(100% - 70px);
    background-color: #fbfcfc;
    border-left: solid 1px #e6ebf1;
    position: fixed;
    right: 0px;
    top: 70px;
    overflow: auto;
}

.design-pannel {
    width: calc(100% - 250px);
    overflow: auto;
}

.design-grid {
    height: calc(100vh - 280px);
}

body[data-theme='dark'] .action-pannel,
body[data-theme='dark'] .template-card {
    border-color: #1c232f;
    background-color: #283142;
}

body[data-theme='dark'] .template-card {
    border-color: #4d5b75;
}

#dashboard-action-tab .ant-tabs-nav-list {
    width: 100%;
    display: flex;
}

#dashboard-action-tab .ant-tabs-nav-list .ant-tabs-tab {
    flex: 1 1;
    justify-content: center;
    margin: 0px;
}

#dashboard-action-tab .ant-tabs-ink-bar {
    width: 50%;
}

.template-card {
    background-color: #fbfcfc;
    border: solid 1px #e6ebf1;
    opacity: 1;
    transform: scale(1);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 3px;
}

.flex-1 {
    flex: 1 1
}

.relative {
    position: relative
}

.flex-col {
    flex-direction: column;
}

.justify-between {
    justify-content: space-between;
}

.gap-1 {
    gap: 1px;
}

.gap-2 {
    gap: 2px;
}

.gap-5 {
    gap: 5px;
}


.rounded {
    border-radius: 4px;
}

.align-start {
    align-items: flex-start;
}

.align-end {
    align-items: flex-end;
}

.align-center {
    align-items: center;
}

.absolute {
    position: absolute;
}

.template-screen {}

.template-screen:hover .template-action {
    opacity: 1;
}

.template-action {
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity ease 0.5s;
    justify-content: center;
    align-items: center;
}

.template-action button {

    /* cursor: pointer; */
    cursor: pointer
}

.rounded-md {
    border-radius: 4px;
}

.rounded-full {
    border-radius: 50%;
}

.justify-center {
    justify-content: center;
}

.overflow-hidden {
    overflow: hidden;
}

.widget-card {
    background-color: #fbfcfc;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 3px;
    cursor: pointer;
}

.widget-header {
    height: 36px;
    border-bottom: solid 1px #e6ebf1;
    ;
    background: transparent;
}

.widget-body {
    height: calc(100% - 36px);
    display: flex;
}

.widget-card--no-header .widget-body,
.widget-body.widget-body--full {
    height: 100%;
}

.widget-body-inner--flush {
    height: 100%;
    width: 100%;
}

/* Mobile / stack: avoid % height collapse when parent only has min-height */
.widget-body.widget-body-stack {
    flex: 1 1 auto;
    height: auto;
    min-height: 140px;
    overflow: visible;
}

.widget-card.widget-card-stack {
    min-height: 100%;
    height: 100%;
}

.dashboard-layout-stack-item .dashboard-widget,
.dashboard-layout-responsive-item .dashboard-widget {
    height: 100%;
}

body[data-theme='dark'] .widget-card {
    border-color: #1c232f;
    background-color: #283142;
}

body[data-theme='dark'] .widget-header,
body[data-theme='dark'] .dashboard-widget {
    border-color: #1c232f;
}

.widget-header .lucide {
    opacity: 0.4;
    transition: opacity ease 0.5s;
}

.widget-header:hover .lucide {
    opacity: 1;
}

.widget-header .widget-category {
    background-color: #d8d8d8;

}

body[data-theme='dark'] .widget-header .widget-category {
    background-color: #4d5b75;
}

.library_category {
    overflow-y: scroll;

}

.library_category .ant-collapse-content-box {
    padding: 6px !important;
    padding-block: 4px !important;

}

.action-pannel .ant-tabs-content {
    height: 100% !important;
}

.scroll-hidden {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.scroll-hidden::-webkit-scrollbar {
    display: none;
}

.library_category .ant-collapse-expand-icon {
    padding-inline-start: 4px !important;
    margin-inline-start: 0px !important;
}

.dashboard-widget {
    transition: all ease 0.2s;
    border: solid 1px #e6ebf1;
}

.widget-active {
    border: 2px solid #3e79f7 !important;
    box-shadow: rgba(37, 99, 235, 0.15) 0px 0px 0px 3px, rgba(0, 0, 0, 0.12) 0px 4px 16px;
}

.widget-active .widget-conner {
    background: #3e79f7;
}

/* ASM Dashboard — theme-aware layout & widget chrome */
.asm-dashboard {
    min-height: 0;
}

.asm-dashboard__content {
    min-height: 0;
}

.asm-dashboard--nationalDay .widget-card {
    background-color: var(--asm-dashboard-card-bg, #ffffff);
    border-color: var(--asm-dashboard-card-border, #e8dcc8);
}

.asm-dashboard--nationalDay .widget-header {
    border-bottom-color: var(--asm-dashboard-card-border, #e8dcc8);
}

.asm-dashboard--nationalDay .widget-header .truncate.text-foreground,
.asm-dashboard--nationalDay .widget-header span.truncate {
    color: var(--asm-dashboard-primary, #9f0000);
}

.asm-dashboard--nationalDay .widget-header .widget-category {
    background-color: #ffc466;
    color: var(--asm-dashboard-primary, #9f0000);
}

.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-card {
    background-color: var(--asm-dashboard-card-bg, #ffffff);
    border-color: var(--asm-dashboard-card-border, #e8dcc8);
}

.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header .truncate.text-foreground,
.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header span.truncate {
    color: var(--asm-dashboard-primary);
}

.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header .widget-category {
    background-color: #ffc466;
    color: var(--asm-dashboard-primary);
}

.absolute {
    position: absolute;
}

.top-0 {
    top: 0px;
}

.bottom-0 {
    bottom: 0px;
}

.left-0 {
    left: 0px;
}

.right-0 {
    right: 0px;
}

.cursor-se-resize {
    cursor: se-resize;
}

.cursor-ne-resize {
    cursor: ne-resize;
}

.scroll-track-y,
.scroll-thumb-y {
    width: 6px !important;
}

.custom-scrollbar .scroll-track-y {
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
}

.custom-scrollbar:hover .scroll-track-y {
    opacity: 1;
    pointer-events: auto;
}

.custom-scrollbar .ScrollbarsCustom-Wrapper {
    inset: 0px !important;
}

.ant-layout {
    position: relative;
    /* z-index: 1000; */
}

.ant-modal-root {
    position: relative;
    /* z-index: 2000; */
}

.theme-effects-layer {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 1100;
    overflow: hidden;
}

.theme-effects-layer canvas {
    pointer-events: none !important;
}

/* Banner 2/9 — ghim góc phải; bottom lấy từ inline style (vd. 55) */
.theme-effects-layer .national-day-footer-pin {
    position: absolute !important;
    right: 0 !important;
    left: auto !important;
    top: auto !important;
}

/* 20/10 — banner nổi trên header (z > 1000); pointer-events: none để vẫn bấm search/icon */
.women-day-header-banner {
    position: fixed;
    top: 0;
    left: calc(50% + 150px);
    transform: translateX(-50%) scale(0.72);
    transform-origin: center top;
    width: min(720px, calc(100vw - 360px));
    height: auto;
    max-height: 120px;
    object-fit: contain;
    object-position: center top;
    pointer-events: none;
    z-index: 1001;
}

.culture-day-header-banner {
    position: fixed;
    top: 5px;
    left: calc(50% + 150px);
    transform: translateX(-50%) scale(0.72);
    transform-origin: center top;
    width: min(720px, calc(100vw - 360px));
    height: auto;
    max-height: 100px;
    object-fit: contain;
    object-position: center top;
    pointer-events: none;
    z-index: 1001;
}

.side-nav-theme-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
}

.side-nav-theme-bg-image {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: contain;
    pointer-events: none;
    z-index: 0;
}

.side-nav-scroll {
    position: relative;
    z-index: 1;
    flex: 1 1;
    min-height: 0;
    height: 100%;
}

.side-nav-scroll>div,
.side-nav-menu-wrapper {
    height: 100%;
}

.tet-branch-left {
    position: fixed;
    top: 0;
    left: 0;
    width: 260px;
    z-index: 12;
    pointer-events: none;
}

.tet-branch-right {
    position: fixed;
    top: 0;
    right: 0;
    width: 260px;
    z-index: 12;
    pointer-events: none;
}

.national-day-branch-left {
    position: fixed;
    top: 0;
    left: 168px;
    width: auto;
    max-width: 110px;
    max-height: 85px;
    height: auto;
    object-fit: contain;
    object-position: left top;
    z-index: 1001;
    pointer-events: none;
}

.theme-logo-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
}

.theme-logo-image {
    width: 65%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

.theme-footer-logo {
    height: 20px;
    width: auto;
    vertical-align: middle;
    margin-inline: 0 4px;
    object-fit: contain;
}

.theme-logo-badge {
    width: 18px;
    height: auto;
    flex-shrink: 0;
    object-fit: contain;
}

.theme-logo-decoration {
    position: fixed;
    top: 0;
    left: 168px;
    width: auto;
    max-width: 110px;
    max-height: 85px;
    height: auto;
    object-fit: contain;
    object-position: left top;
    z-index: 1001;
    pointer-events: none;
}

.theme-logo-decoration--tet {
    max-width: 96px;
    max-height: 72px;
}

.theme-logo-decoration--women-day {
    max-width: 88px;
    max-height: 68px;
}

.theme-logo-decoration--noel {
    max-width: 120px;
    max-height: 90px;
}

.theme-logo-decoration--culture-day {
    left: calc(168px + 16px);
    top: 5px;
}

.custom-menu .ant-menu-item-icon,
.custom-menu .anticon {
    width: 20px;
    min-width: 20px;
    margin-right: 8px !important;
}

.custom-menu .ant-menu-item .ant-menu-item-icon,
.custom-menu .ant-menu-submenu-title .ant-menu-item-icon,
.custom-menu .ant-menu-item .anticon,
.custom-menu .ant-menu-submenu-title .anticon {
    margin-inline-end: 0px !important;
}

.ant-menu-item,
.ant-menu-submenu-title {
    display: flex !important;
}

/* Custom Tabs — nagaco-custom-tabs / erp-tabs (folder-style, mockup ERP) */
.nagaco-custom-tabs,
.erp-tabs {
    --nagaco-tab-gap: 12px;
    --nagaco-tab-padding-x: 14px;
    --nagaco-tab-radius: 14px;
    --nagaco-tab-arch: 26px;
    --nagaco-tab-valley: 7px;
    --nagaco-tab-border-width: 1px;
    --nagaco-tab-border: #d4d4d4;
    --nagaco-tab-nav-bg: #f0f0f0;
    --nagaco-tab-primary: var(--ant-color-primary, #1677ff);
    overflow: visible;
}

/* ── Nav bar ── */
.nagaco-custom-tabs__nav {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    margin: 0;
    padding: 10px 12px calc(var(--nagaco-tab-valley) + 4px);
    background: var(--nagaco-tab-nav-bg);
    border-radius: 10px 10px 0 0;
    overflow: visible;
}

/* ── Tab item ── */
/* toàn bộ thanh */

.wizard-step {

    overflow-x: auto;

    white-space: nowrap;

    padding: 8px 0;

}

/* step */

.wizard-step .ant-steps-item {

    flex: 1 1;

}

/* container */

.wizard-step .ant-steps-item-container {

    display: flex;

    align-items: center;

}

/* bỏ line mặc định */

.wizard-step .ant-steps-item-tail {

    display: none;
}

/* icon */

.wizard-step .ant-steps-item-icon {

    margin: 0;

    width: 28px;

    height: 28px;

    line-height: 28px;

    border-radius: 50%;

    border: none;

    background: #ececec;

    color: #666;

    font-size: 14px;

    transition: .25s;

}

/* title */

.wizard-step .ant-steps-item-title {

    margin-left: 10px;

    padding: 8px 22px;

    border-radius: 28px;

    border: 1px solid #bfbfbf;

    background: white;

    color: #666;

    font-size: 15px;

    line-height: 1;

    position: relative;

    transition: .25s;

}

/* ẩn description */

.wizard-step .ant-steps-item-description {

    display: none;
}

/* bỏ ::after mặc định */

.wizard-step .ant-steps-item-title::after {

    display: none !important;

}

/* active */

.wizard-step .ant-steps-item-process .ant-steps-item-title {

    color: #1677ff;

    border-color: #1677ff;

    background:

        linear-gradient(to bottom,
            #dcebff,
            #ffffff 55%);

    box-shadow:

        0 2px 8px rgba(22, 119, 255, .15);

}

.wizard-step .ant-steps-item-process .ant-steps-item-icon {

    background: #dcebff;

    color: #1677ff;

}

/* finish */

.wizard-step .ant-steps-item-finish .ant-steps-item-title {

    border-color: #91caff;

}

/* connector */

.wizard-step .ant-steps-item:not(:last-child) .ant-steps-item-title::before {

    content: "";

    position: absolute;

    top: 50%;

    right: -18px;

    transform: translateY(-50%);

    width: 20px;

    height: 20px;

    border-top: 3px solid #1677ff;

    border-right: 3px solid #1677ff;

    border-radius: 0 20px 0 0;

}

/* hover */

.wizard-step .ant-steps-item:hover .ant-steps-item-title {

    border-color: #1677ff;

    color: #1677ff;

}

/* Striped rows — chỉ áp dụng theme light; dark giữ mặc định Ant Design */
/* :not(.nagaco-comment-cell) để không đè màu nền báo lỗi/thành công của cột "notes" khi import */
body[data-theme='light'] .ant-table-row.table-row-light>.ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-light>td:not(.nagaco-comment-cell) {
    background: #ffffff !important;
}

body[data-theme='light'] .ant-table-row.table-row-dark>.ant-table-cell:not(.nagaco-comment-cell),
body[data-theme='light'] .table-row-dark>td:not(.nagaco-comment-cell) {
    background: #f5f5f5 !important;
}

/* Striped rows hover/selected — lightTheme.js lightScopedStyles (theo colorPrimary) */

/* Purchase group form card — taller header, title vertically centered */
.purchase-group-form-card>.ant-card-head {
    height: 54px !important;
    min-height: 50px !important;
    padding: 0 16px !important;
    border-bottom: none;
    display: flex;
    align-items: center;
}

.purchase-group-form-card>.ant-card-head .ant-card-head-wrapper {
    width: 100%;
    height: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
}

.purchase-group-form-card>.ant-card-head .ant-card-head-title {
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1.4;
    display: flex;
    align-items: center;
}

/* Detail card header — title + pill action groups */
.detail-card-with-action-header>.ant-card-head {
    border-bottom: none;
    min-height: auto !important;
    padding: 6px 16px !important;
}

.detail-card-with-action-header>.ant-card-head .ant-card-head-wrapper {
    min-height: auto;
    padding: 0;
}

.detail-card-with-action-header>.ant-card-head .ant-card-head-title {
    padding: 0;
    min-height: auto;
    line-height: 1;
}

.detail-card-with-action-header>.ant-card-head .ant-card-extra {
    padding: 0 !important;
    margin-inline-start: 12px;
    display: inline-flex;
    align-items: center;
    align-self: center;
}

.detail-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;
    min-height: 38px;
}

.detail-card-header-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: inherit;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.4;
}

.detail-card-header-chevron {
    flex-shrink: 0;
    font-size: 12px;
    opacity: 0.95;
}

.detail-action-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
}

.detail-action-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 6px;
    background: #fff;
    border-radius: 999px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.detail-action-pill .ant-tooltip-disabled-compatible-wrapper {
    display: inline-flex;
    line-height: 0;
}

.ant-btn.detail-back-btn.ant-btn-primary,
button.ant-btn.detail-back-btn.ant-btn-primary {
    background-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    background: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    border-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    color: var(--detail-theme-action-color, #fff) !important;
    box-shadow: none !important;
}

.ant-btn.detail-back-btn--in-card.ant-btn-primary,
button.ant-btn.detail-back-btn--in-card.ant-btn-primary {
    background-color: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    background: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    border-color: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    color: var(--detail-theme-action-in-card-color, var(--detail-theme-action-color, #fff)) !important;
}

.ant-btn.detail-back-btn.ant-btn-primary .anticon,
.ant-btn.detail-back-btn.ant-btn-primary .anticon svg,
.ant-btn.detail-back-btn--in-card.ant-btn-primary .anticon,
.ant-btn.detail-back-btn--in-card.ant-btn-primary .anticon svg {
    color: inherit !important;
    fill: currentColor !important;
}

.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):hover,
.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):focus,
.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):hover,
.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):focus {
    filter: brightness(1.08);
}

.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):hover,
.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):focus {
    background-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    background: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    border-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;
    color: var(--detail-theme-action-color, #fff) !important;
}

.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):hover,
.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):focus {
    background-color: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    background: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    border-color: var(
        --detail-theme-action-in-card-bg,
        var(--detail-theme-action-bg, var(--ant-color-primary))
    ) !important;
    color: var(--detail-theme-action-in-card-color, var(--detail-theme-action-color, #fff)) !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn {
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 0;
    border-width: 1.5px;
    box-shadow: none !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn .anticon {
    font-size: 14px;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-default {
    background: var(--detail-action-primary, var(--ant-color-primary)) !important;
    border-color: var(--detail-action-primary, var(--ant-color-primary)) !important;
    color: #ffffff !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn .anticon,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary .anticon {
    color: #ffffff !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn:not(:disabled):hover,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary:not(:disabled):hover,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-default:not(:disabled):hover {
    background: var(--detail-action-primary, var(--ant-color-primary)) !important;
    border-color: var(--detail-action-primary, var(--ant-color-primary)) !important;
    color: #ffffff !important;
    filter: brightness(1.08);
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-default,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-primary {
    background: #ffffff !important;
    border-color: var(--ant-color-primary) !important;
    color: var(--ant-color-primary) !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn:not(:disabled):hover,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-default:not(:disabled):hover,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-primary:not(:disabled):hover {
    background: #ffffff !important;
    border-color: var(--ant-color-primary) !important;
    color: var(--ant-color-primary) !important;
    opacity: 0.85;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default {
    background: #ff4d4f !important;
    border-color: #ff4d4f !important;
    color: #ffffff !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:not(:disabled):hover,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:not(:disabled):hover {
    background: #ff7875 !important;
    border-color: #ff7875 !important;
    color: #ffffff !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn .anticon,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default .anticon {
    color: #ffffff !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn:disabled,
.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-default:disabled,
.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-primary:disabled {
    background: #f5f5f5 !important;
    border-color: #d9d9d9 !important;
    color: rgba(0, 0, 0, 0.45) !important;
    opacity: 1 !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn:disabled .anticon,
.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-default:disabled .anticon,
.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-primary:disabled .anticon {
    color: rgba(0, 0, 0, 0.45) !important;
}

/* Delete disabled: keep danger cue but readable on light pill */
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:disabled,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:disabled,
.detail-card-with-action-header .detail-action-pill #delete_record.ant-btn:disabled {
    background: #fff1f0 !important;
    border-color: #ffa39e !important;
    color: #cf1322 !important;
    opacity: 1 !important;
}

.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:disabled .anticon,
.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:disabled .anticon,
.detail-card-with-action-header .detail-action-pill #delete_record.ant-btn:disabled .anticon {
    color: #cf1322 !important;
}

.side-nav-module-menu-rail .ant-menu-item>span {
    display: block !important;
}

.truncate {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.text-right .ant-input-number-input {
    text-align: right;
}

.text-black .ant-input-number-input {
    color: #455560;
}

.ant-main-card {
    border-radius: 22px;
    /* Không set z-index ở đây — sẽ tạo stacking context khiến
       .fullscreen-action-* (position:fixed) bị side-nav/header đè */
    border: 1px solid #d9e6ff;
    border-top: 4px solid var(--ant-color-primary, #1677ff);
    border-width: 3px 0px 0px 0px;
    box-shadow: 0 4px 16px rgba(51, 75, 196, 0.08);
    margin-bottom: 16px;
}

/* Dashboard module cards — viền đủ 4 cạnh + top accent (dark: accent #0052AD, không dùng colorPrimary #1b2531) */
.ant-main-card.dashboard-module-card {
    border-style: solid;
    border-color: var(--module-card-side-border, #d9e6ff);
    border-width: 1px;
    border-top-width: 3px;
    border-top-color: var(--module-card-accent, var(--ant-color-primary, #1677ff));
}

body[data-theme='dark'] .ant-main-card.dashboard-module-card {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
}

.ant-main-card .ant-card-body {
    height: 100%;
}

/* Dashboard module card — «Mở phân hệ» (dark: trắng + accent; hover/active: nền accent) */
.module-card-open-module-btn.ant-btn-default:not(:disabled) {
    color: var(--module-card-open-btn-label, var(--module-card-open-btn-accent, #1677ff)) !important;
    border-color: var(--module-card-open-btn-accent, #1677ff) !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.module-card-open-module-btn.ant-btn-default:not(:disabled):hover,
.module-card-open-module-btn.ant-btn-default:not(:disabled):active,
.module-card-open-module-btn.ant-btn-default:not(:disabled):focus-visible {
    color: #fff !important;
    background-color: var(--module-card-open-btn-accent, #1677ff) !important;
    border-color: var(--module-card-open-btn-accent, #1677ff) !important;
}

.module-card-open-module-btn--dark.ant-btn-default:not(:disabled):active {
    filter: brightness(1.12);
}

.module-card-open-module-btn.ant-btn-default:not(:disabled) .ant-btn-icon,
.module-card-open-module-btn.ant-btn-default:not(:disabled) svg {
    color: inherit;
}

.ant-left-card {
    border-radius: 22px;
    position: 'sticky';
    bottom: 0;
    z-index: 100;
    border: 1px solid #d9e6ff;
    border-left: 4px solid var(--ant-color-primary, #1677ff);
    border-width: 0px 0px 0px 3px;
    box-shadow: 0 -8px 24px rgba(51, 75, 196, 0.12);
    /* margin: 18px; */
}


.breadcrumb-container {
    /* padding: 6px 18px; */
    margin: -16px -16px 16px -16px;
    padding: 6px 16px;
}

.variable-row>span>span:nth-child(2) {
    color: var(--rmg-gray-400, gray) !important;
}

.object-key {
    color: var(--ant-color-primary, #1677ff) !important;
}

.variable-editor {
    background-color: white !important;
}

.ant-menu-item-group-title {
    padding-left: 15px !important;
}

/* custom-menu selected chrome — không áp lên module-menu rail */
.custom-menu .ant-menu-item-selected,
.custom-menu-popup .ant-menu-item-selected,
.ant-menu-submenu-popup .ant-menu-item-selected,
.ant-menu-submenu-selected>.ant-menu-submenu-title {
    /* transition: all 1s ease !important; */
    margin-left: 15px !important;
    border-radius: 0 24px 24px 0 !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    /* Phải set màu tường minh — thiếu màu sẽ ăn currentColor (chữ tối → vạch đen) */
    border-left: 5px solid var(--nagaco-menu-active-bar, #ffd700) !important;
    box-shadow: none !important;
    width: calc(100% - 24px) !important;
}

/* custom-menu / popup — không áp lên module-menu rail */
.custom-menu .ant-menu-item-selected,
.custom-menu-popup .ant-menu-item-selected,
.ant-menu-submenu-popup .ant-menu-item-selected,
.ant-menu-submenu-selected>.ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-submenu-selected>.ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-submenu-active>.ant-menu-submenu-title,
.ant-menu-popup .ant-menu-submenu-selected>.ant-menu-submenu-title,
.ant-menu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,
.custom-menu-popup-collapsed .ant-menu-submenu-selected>.ant-menu-submenu-title,
.custom-menu-popup-collapsed .ant-menu-submenu-open>.ant-menu-submenu-title,
.custom-menu-popup-collapsed .ant-menu-submenu-active>.ant-menu-submenu-title,
.custom-menu-popup-collapsed.ant-menu .ant-menu-submenu-selected>.ant-menu-submenu-title,
.custom-menu-popup-collapsed.ant-menu .ant-menu-submenu-open>.ant-menu-submenu-title {
    background: var(--nagaco-menu-active-bg, #fff8ed) !important;
    background-color: var(--nagaco-menu-active-bg, #fff8ed) !important;
}

.ant-menu-submenu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,
.ant-menu-submenu-popup .ant-menu-submenu-active>.ant-menu-submenu-title,
.ant-menu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,
.custom-menu-popup-collapsed .ant-menu-submenu-open>.ant-menu-submenu-title,
.custom-menu-popup-collapsed .ant-menu-submenu-active>.ant-menu-submenu-title {
    margin-left: 15px !important;
    border-left: 5px solid var(--nagaco-menu-active-bar, #ffd700) !important;
    border-radius: 0 24px 24px 0 !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    box-shadow: none !important;
    width: calc(100% - 24px) !important;
}

.custom-menu .ant-menu-item-selected,
.custom-menu-popup .ant-menu-item-selected,
.ant-menu-submenu-popup .ant-menu-item-selected,
.ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: var(--nagaco-menu-active-text, var(--ant-menu-item-selected-color, inherit)) !important;
}

.custom-menu .ant-menu-item-selected .ant-menu-title-content,
.custom-menu .ant-menu-item-selected .nav-item_title,
.custom-menu .ant-menu-item-selected .nav-item_flex,
.custom-menu .ant-menu-item-selected .nav-item_flex span,
.custom-menu-popup .ant-menu-item-selected .ant-menu-title-content,
.custom-menu-popup .ant-menu-item-selected .nav-item_title,
.ant-menu-submenu-popup .ant-menu-item-selected .ant-menu-title-content,
.ant-menu-submenu-popup .ant-menu-item-selected .nav-item_title,
.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-title-content,
.ant-menu-submenu-selected > .ant-menu-submenu-title .nav-item_title,
.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .nav-item_title {
    color: var(--nagaco-menu-active-text, var(--ant-menu-item-selected-color, inherit)) !important;
}

.custom-menu .ant-menu-item-selected .ant-menu-item-icon,
.custom-menu .ant-menu-item-selected .ant-menu-item-icon .anticon,
.custom-menu .ant-menu-item-selected .anticon,
.custom-menu .ant-menu-item-selected .anticon svg,
.custom-menu-popup .ant-menu-item-selected .ant-menu-item-icon,
.custom-menu-popup .ant-menu-item-selected .anticon,
.ant-menu-submenu-popup .ant-menu-item-selected .ant-menu-item-icon,
.ant-menu-submenu-popup .ant-menu-item-selected .anticon,
.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon,
.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon svg,
.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-expand-icon,
.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-expand-icon .anticon,
.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .anticon {
    color: var(--nagaco-menu-active-icon, var(--nagaco-menu-active-text, var(--ant-color-primary, #9f0000))) !important;
    fill: var(--nagaco-menu-active-icon, var(--nagaco-menu-active-text, var(--ant-color-primary, #9f0000))) !important;
}

.ant-card .ant-card-body {
    padding: 15px 20px;
}

.ant-tooltip-inner {
    min-height: unset !important;
}

/* Simplify / Detailed switch — white text on primary header, clear of handle */
.nagaco-simplify-switch.ant-switch {
    background: rgba(255, 255, 255, 0.2);
    min-width: 96px;
    height: 26px;
    line-height: 26px;
}

.nagaco-simplify-switch.ant-switch.ant-switch-checked {
    background: rgba(255, 255, 255, 0.32);
}

.nagaco-simplify-switch.ant-switch .ant-switch-inner {
    display: block !important;
    position: relative;
    height: 26px !important;
    line-height: 26px !important;
    font-size: 13px !important;
    font-weight: 600;
    letter-spacing: 0.02em;
    /* Unchecked: handle on the left — push text right */
    padding-inline-start: 28px !important;
    padding-inline-end: 8px !important;
}

.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-inner {
    /* Checked: handle on the right — push text left */
    padding-inline-start: 8px !important;
    padding-inline-end: 28px !important;
}

.nagaco-simplify-switch.ant-switch .ant-switch-inner-checked,
.nagaco-simplify-switch.ant-switch .ant-switch-inner-unchecked {
    display: none !important;
    align-items: center !important;
    justify-content: center !important;
    height: 26px !important;
    line-height: 1 !important;
    margin: 0 !important;
    padding-block: 0 !important;
    color: #fff !important;
}

/* Unchecked state → only show "Đầy đủ" */
.nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) .ant-switch-inner-unchecked {
    display: inline-flex !important;
}

/* Checked state → only show "Rút gọn" */
.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-inner-checked {
    display: inline-flex !important;
}

.nagaco-simplify-switch.ant-switch .ant-switch-handle {
    width: 20px;
    height: 20px;
    top: 3px;
    inset-inline-start: 3px;
}

.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-handle {
    inset-inline-start: calc(100% - 23px);
}

.nagaco-simplify-switch.ant-switch .ant-switch-handle::before {
    border-radius: 10px;
}

body[data-theme='dark'] .nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) {
    background: rgba(255, 255, 255, 0.2);
}

body[data-theme='dark'] .nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) .ant-switch-inner-unchecked {
    color: #fff;
}

body[data-theme='dark'] .nagaco-simplify-switch.ant-switch.ant-switch-checked {
    background: rgba(255, 255, 255, 0.32);
}

/* Theme configurator — card layout matching design mock */

.theme-configurator-drawer .ant-drawer-header {
    padding: 14px 16px;
    background: var(--theme-config-drawer-header-bg, #faf8f5);
    border-bottom: 2px solid var(--theme-config-primary, #a00000);
}

.theme-configurator-drawer .ant-drawer-header-title {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: 12px;
}

.theme-configurator-drawer .ant-drawer-title {
    flex: 1 1;
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--theme-config-drawer-title, rgba(0, 0, 0, 0.88));
    order: 1;
}

.theme-configurator-drawer__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.theme-configurator-drawer__chevron {
    font-size: 11px;
    color: var(--theme-config-primary, #a00000);
}

.theme-configurator-drawer .ant-drawer-close {
    position: static;
    order: 2;
    margin-inline-start: auto;
    inset: unset;
    width: 28px;
    height: 28px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.theme-configurator-drawer .ant-drawer-close:hover {
    background: transparent;
}

.theme-configurator-drawer__close-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid var(--theme-config-primary, #a00000);
    background: var(--theme-config-primary-bg, #fff1f0);
    color: var(--theme-config-primary, #a00000);
    font-size: 12px;
    line-height: 1;
}

.theme-configurator-drawer .ant-drawer-body {
    padding: 0 !important;
    background: var(--theme-config-drawer-bg, #f0f0f0);
}

.theme-configurator-drawer .ant-drawer-content {
    background: var(--theme-config-drawer-bg, #f0f0f0);
}

.theme-configurator {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 12px var(--theme-config-card-gutter-x, 12px);
}

.theme-configurator .ant-main-card {
    margin-bottom: 0;
}

.theme-configurator .ant-main-card .ant-card-body {
    padding: var(--theme-config-card-body-inset, 12px) !important;
}

.theme-configurator__card {
    background: var(--theme-config-drawer-surface, #fff);
    border-radius: 16px;
    overflow: hidden;
    border-top: 3px solid var(--theme-config-primary, #a00000);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.theme-configurator__card-body {
    margin: 0;
}

.theme-configurator__card-title {
    margin: 0;
    padding: 0 0 10px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--theme-config-label, rgba(0, 0, 0, 0.88));
}

.theme-configurator__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 48px;
    padding: 10px 0;
    border-top: 1px solid var(--theme-config-option-border, #f0f0f0);
}

.theme-configurator__option--danger {
    background: var(--theme-config-danger-row-bg, var(--theme-config-primary-bg, #f5f5f5));
    margin-inline: calc(-1 * var(--theme-config-card-body-inset, 12px));
    padding-inline: var(--theme-config-card-body-inset, 12px);
}

.theme-configurator__option--disabled .theme-configurator__option-label,
.theme-configurator__option--disabled .theme-configurator__option-control {
    opacity: 0.35;
    pointer-events: none;
}

.theme-configurator__option-label {
    flex: 1 1;
    min-width: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: var(--theme-config-label, rgba(0, 0, 0, 0.88));
}

.theme-configurator__option-control {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 58%;
}

/* Pill segmented Radio.Group */
.theme-configurator__segmented.ant-radio-group {
    display: inline-flex;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 999px;
    overflow: hidden;
    padding: 0;
}

.theme-configurator__segmented .ant-radio-button-wrapper {
    height: 30px;
    line-height: 28px;
    padding: 0 14px;
    border: none !important;
    border-radius: 0 !important;
    background: transparent;
    color: rgba(0, 0, 0, 0.65);
    box-shadow: none !important;
}

.theme-configurator__segmented .ant-radio-button-wrapper::before {
    display: none !important;
}

.theme-configurator__segmented .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: var(--theme-config-primary, #a00000) !important;
    color: #fff !important;
}

.theme-configurator__segmented .ant-radio-button-wrapper:hover {
    color: var(--theme-config-primary, #a00000);
}

.theme-configurator__segmented .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
}

/* Theme select pill */
.theme-configurator__pill.ant-select {
    min-width: 130px;
    max-width: 160px;
}

.theme-configurator__pill.ant-select .ant-select-selector {
    height: 32px !important;
    border-radius: 999px !important;
    padding-inline: 12px !important;
    align-items: center;
}

.theme-configurator__pill.ant-select .ant-select-selection-item,
.theme-configurator__pill.ant-select .ant-select-selection-placeholder {
    line-height: 30px !important;
    display: flex;
    align-items: center;
}

.theme-configurator__pill.ant-input-number {
    width: 88px;
    height: 32px;
    border-radius: 999px;
    overflow: hidden;
}

.theme-configurator__pill.ant-input-number .ant-input-number-input {
    height: 30px;
    text-align: center;
}

.theme-configurator__lang.ant-btn,
.theme-configurator__lang {
    height: 32px;
    padding: 0 12px;
    border-radius: 999px !important;
    border: 1px solid #d9d9d9;
    background: #fff;
    display: inline-flex;
    align-items: center;
}

.theme-configurator__delete {
    font-size: 18px;
    color: var(--ant-color-error, #ff4d4f);
    cursor: pointer;
    line-height: 1;
}

.theme-configurator__delete:hover {
    opacity: 0.85;
}

.theme-configurator .color-picker .color-picker-dropdown {
    border-radius: 8px;
    padding: 3px;
    border: 1px solid #d9d9d9;
    background: #fff;
}

.theme-configurator .color-picker .color {
    width: 48px;
    height: 20px;
    border-radius: 6px;
    border: none;
}

body[data-theme='dark'] .theme-configurator__option {
    border-top-color: var(--ant-color-border, #303030);
}

body[data-theme='dark'] .theme-configurator__option--danger {
    background: var(--theme-config-drawer-surface, #262626);
}

/* System notification drawer */

.nav-consumer-notification-drawer .ant-drawer-header {
    padding: 12px 16px;
    background: var(--nagaco-drawer-header-bg, var(--nagaco-drawer-primary-bg, #fcf8f2));
    border-bottom: 2px solid var(--nagaco-drawer-primary, #a00000);
}

.nav-consumer-notification-drawer .ant-drawer-title {
    font-size: 15px;
    font-weight: 700;
    color: var(--nagaco-drawer-title-color, rgba(0, 0, 0, 0.88));
}

.nav-consumer-notification-drawer__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.nav-consumer-notification-drawer__chevron {
    font-size: 11px;
    color: var(--nagaco-drawer-primary, #a00000);
}

.nav-consumer-notification-drawer__action-btn.ant-btn {
    height: 28px;
    padding: 0 14px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: rgba(0, 0, 0, 0.88) !important;
    background: #fff !important;
    border: none !important;
    box-shadow: none !important;
}

.nav-consumer-notification-drawer__action-btn.ant-btn .anticon {
    font-size: 10px;
    color: inherit;
}

.nav-consumer-notification-drawer__action-btn.ant-btn:hover,
.nav-consumer-notification-drawer__action-btn.ant-btn:focus {
    color: rgba(0, 0, 0, 0.88) !important;
    background: #fff !important;
    border: none !important;
    opacity: 0.92;
}

.nav-consumer-notification-drawer .ant-drawer-body {
    padding: 12px 14px;
    background: #f5f2ec;
}

.nav-consumer-notification-drawer .ant-drawer-footer {
    padding: 12px 16px 16px;
    background: #f5f2ec;
    border-top: none;
}

.nagaco-drawer-extra {
    display: flex;
    align-items: center;
    gap: 10px;
}

.nagaco-drawer-extra__actions {
    display: inline-flex;
    align-items: center;
}

.nagaco-drawer-extra__zoom.ant-btn {
    width: 32px;
    height: 32px;
    min-width: 32px;
}

.nagaco-drawer-extra__close.ant-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 8px;
}

.nav-notification-actions-btn.ant-btn {
    height: 32px;
    border-radius: 999px;
    padding-inline: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.nav-notification-wrapper {
    height: 100%;
}

.nav-notification-body {
    padding: 0 2px 8px;
}

.nav-notification-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: var(--nav-notification-list-gutter-top, 12px);
    margin-inline: var(--nav-notification-list-gutter-x, 12px);
}

.nav-notification-card {
    display: flex;
    align-items: stretch;
    gap: 10px;
    padding: 12px 12px 12px 10px;
    border-radius: 16px;
    background: linear-gradient(90deg, #ffffff 0%, #fff8ef 100%);
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;
}

.nav-notification-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.nav-notification-card.is-unread {
    background: linear-gradient(90deg, #fff7f5 0%, #fff1e8 100%);
}

.nav-notification-card__icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid var(--nagaco-drawer-primary, #a00000);
    background: #fff;
    color: var(--nagaco-drawer-primary, #a00000);
    font-size: 18px;
    margin-top: 2px;
}

.nav-notification-card.is-unread .nav-notification-card__icon {
    background: var(--nagaco-drawer-primary, #a00000);
    color: #fff;
    border-color: var(--nagaco-drawer-primary, #a00000);
}

.nav-notification-card__main {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;
}

.nav-notification-card__title {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
    color: rgba(0, 0, 0, 0.88);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.nav-notification-card.is-expanded .nav-notification-card__title {
    display: block;
    -webkit-line-clamp: unset;
    overflow: visible;
}

.nav-notification-card__title a,
.nav-notification-card__title strong,
.nav-notification-card__title b,
.nav-notification-card__title span[style*='color'] {
    font-weight: 700;
}

.nav-notification-card__desc {
    margin: 0;
    font-size: 12px;
    line-height: 1.45;
    color: rgba(0, 0, 0, 0.55);
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.nav-notification-card.is-expanded .nav-notification-card__desc {
    display: block;
    -webkit-line-clamp: unset;
    overflow: visible;
}

.nav-notification-card__toggle {
    flex-shrink: 0;
    align-self: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: rgba(0, 0, 0, 0.45);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 11px;
    padding: 0;
    transition: all 0.2s ease;
}

.nav-notification-card__toggle:hover {
    border-color: var(--nagaco-drawer-primary, #a00000);
    color: var(--nagaco-drawer-primary, #a00000);
}

.nav-notification-card.is-unread .nav-notification-card__toggle,
.nav-notification-card.is-expanded .nav-notification-card__toggle {
    background: var(--nagaco-drawer-primary, #a00000);
    border-color: var(--nagaco-drawer-primary, #a00000);
    color: #fff;
}

.nav-notification-card__toggle.is-open .anticon {
    transform: rotate(180deg);
}

.nav-notification-card__divider {
    width: 1px;
    align-self: stretch;
    margin: 4px 2px;
    background: #e8e8e8;
    flex-shrink: 0;
}

.nav-notification-card__meta {
    flex-shrink: 0;
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 108px;
}

.nav-notification-card__meta-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #d4a017;
    white-space: nowrap;
}

.nav-notification-card__meta-row .anticon {
    font-size: 13px;
    color: #e0b12a;
}

.nav-notification-card__more {
    flex-shrink: 0;
    align-self: center;
}

.nav-notification-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 40px 16px;
    color: rgba(0, 0, 0, 0.45);
}

.nav-notification-footer {
    display: flex;
    justify-content: center;
    width: 100%;
}

.nav-notification-footer__btn.ant-btn {
    min-width: 180px;
    height: 40px;
    border-radius: 999px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

body[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-header {
    background: var(--nagaco-drawer-header-bg, #1f1f1f);
}

body[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-body,
body[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-footer {
    background: var(--nagaco-drawer-body-bg, var(--ant-color-bg-layout, #141414));
}

.nav-consumer-notification-drawer .ant-drawer-body,
.nav-consumer-notification-drawer .ant-drawer-footer {
    background: var(--nagaco-drawer-body-bg, #f5f5f5);
}

body[data-theme='dark'] .nav-notification-card {
    background: linear-gradient(90deg, #1f1f1f 0%, #2a241c 100%);
    border-color: #303030;
}

body[data-theme='dark'] .nav-notification-card__title {
    color: rgba(255, 255, 255, 0.88);
}

body[data-theme='dark'] .nav-notification-card__desc {
    color: rgba(255, 255, 255, 0.45);
}

body[data-theme='dark'] .nav-notification-card__divider {
    background: #303030;
}

/* Local storage notifications popover */

.nav-local-notification-popover .ant-popover-inner {
    padding: 0 !important;
    overflow: hidden;
    border-radius: 22px;
    z-index: 1;
    border: 1px solid var(--nav-noti-split, #d9e6ff);
    border-top: 4px solid var(--nav-noti-primary, var(--ant-color-primary, #1677ff));
    border-width: 3px 0 0 0;
    box-shadow: 0 4px 16px rgba(51, 75, 196, 0.08);
    background: var(--nav-noti-bg, #fff);
}

.nav-local-notification-popover .ant-popover-inner-content {
    padding: 0 !important;
}

.nav-local-notification {
    width: 340px;
    max-width: min(340px, 92vw);
    background: var(--nav-noti-bg, #fff);
    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));
}

.nav-local-notification__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border-bottom: 1px solid var(--nav-noti-split, #f0f0f0);
}

.nav-local-notification__title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));
}

.nav-local-notification__pill-btn.ant-btn {
    height: 28px;
    padding: 0 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
    color: var(--nav-noti-pill-color, var(--nav-noti-primary, #1677ff)) !important;
    border-color: var(
        --nav-noti-pill-border-color,
        var(--nav-noti-primary-border, var(--nav-noti-primary, #1677ff))
    ) !important;
    background: transparent !important;
    box-shadow: none !important;
}

.nav-local-notification__pill-btn.ant-btn:hover,
.nav-local-notification__pill-btn.ant-btn:focus {
    color: var(--nav-noti-pill-hover-color, #fff) !important;
    background: var(--nav-noti-pill-hover-bg, var(--nav-noti-primary, #1677ff)) !important;
    border-color: var(
        --nav-noti-pill-hover-border,
        var(--nav-noti-primary, #1677ff)
    ) !important;
}

.nav-local-notification__body {
    max-height: 360px;
    overflow: auto;
}

.nav-local-notification__list.ant-list .ant-list-item.nav-local-notification__item {
    padding: 0;
    margin: 0;
    border: none !important;
}

.nav-local-notification__item-inner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 12px 14px;
    border-bottom: 1px solid var(--nav-noti-split, #e8e8e8);
}

.nav-local-notification__list.ant-list .ant-list-item.nav-local-notification__item:last-child .nav-local-notification__item-inner {
    border-bottom: none;
}

.nav-local-notification__avatar {
    flex-shrink: 0;
}

.nav-local-notification__avatar .ant-avatar,
.nav-local-notification__avatar-icon.ant-avatar {
    width: 36px;
    height: 36px;
    line-height: 36px;
    background: var(--nav-noti-error-bg, #fff1f0);
    color: var(--nav-noti-error, #ff4d4f);
}

.nav-local-notification__avatar-icon.ant-avatar-success {
    background: var(--ant-color-success-bg, #f6ffed);
    color: var(--ant-color-success, #52c41a);
}

.nav-local-notification__avatar-icon.ant-avatar-info {
    background: var(--nav-noti-primary-bg, #e6f4ff);
    color: var(--nav-noti-primary, #1677ff);
}

.nav-local-notification__content {
    flex: 1 1;
    min-width: 0;
}

.nav-local-notification__desc {
    font-size: 13px;
    line-height: 1.45;
    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));
}

.nav-local-notification__name {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.4;
    text-transform: uppercase;
    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));
    word-break: break-word;
}

.nav-local-notification__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 8px;
}

.nav-local-notification__time {
    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));
    font-size: 12px;
    white-space: nowrap;
}

.nav-local-notification__footer {
    padding: 12px 14px;
    text-align: center;
    background: var(--nav-noti-footer-bg, #faf5ef);
    border-top: 1px solid var(--nav-noti-split, #f0f0f0);
}

.nav-local-notification__footer-link {
    color: var(--nav-noti-footer-link, var(--nav-noti-primary, #a00000));
    font-weight: 600;
    font-size: 13px;
    text-decoration: none;
}

.nav-local-notification__footer-link:hover {
    color: var(--nav-noti-primary, #a00000);
    text-decoration: underline;
}

.nav-local-notification__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 28px 16px;
    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));
}

body[data-theme='dark'] .nav-local-notification-popover .ant-popover-inner {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
}

.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {
    display: block !important;
}

.nagaco-date-range-picker-popup .ant-picker-cell-inner {
    border-radius: 50% !important;
}

.nagaco-date-range-picker-popup .ant-picker-cell-range-start .ant-picker-cell-inner,
.nagaco-date-range-picker-popup .ant-picker-cell-range-end .ant-picker-cell-inner {
    border-radius: 50% !important;
}

.nagaco-date-range-picker-popup .ant-picker-cell-today .ant-picker-cell-inner::before {
    border-radius: 50% !important;
}
.table-wrapper-mf, .table-wrapper{
	border-radius: 16px 16px 0 0;
}
.ant-drawer .ant-drawer-body 
{
    padding: 0px !important;
}

.nagaco-custom-drawer .ant-drawer-title {
    color: var(--nagaco-drawer-title-color, inherit);
}

.nagaco-custom-drawer .ant-drawer-header {
    background: var(--nagaco-drawer-header-bg, inherit);
}

.nagaco-custom-drawer .ant-drawer-body {
    background: var(--nagaco-drawer-body-bg, inherit);
    color: var(--nagaco-drawer-text-color, inherit);
}

.nagaco-custom-drawer .ant-drawer-footer {
    background: var(--nagaco-drawer-footer-bg, var(--nagaco-drawer-body-bg, inherit));
}

.line-clamp-2 {
    /* background-color: gray; */
    /* margin-left: -20px; */
    padding: 15px 20px;
    width: calc(100% + 40px);
    /* background: #BFBFBF; */
    border-top: solid 1px #BFBFBF;
    border-bottom: solid 1px #BFBFBF;
    background: linear-gradient(0deg,rgba(191, 191, 191, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

.statistic-item + .statistic-item {
    border-top: solid 1px #BFBFBF;

}

.bom-modal-root, 
.nagaco-overlay-root {
    
    z-index: 1000 !important;
}

.national-day-branch-left{ 
    /* left: 175px  */
    margin-left: 10px;
}

.label-warning {
    color: #B85814 !important;
}

.label-success {
    color: #2D8643 !important;
}

.label-danger {
    color: #CF0505 !important;
}

/* .popup-drawer {
    z-index: 2200 !important;
} */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,mEAAmE;AACnE;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,0DAA0D;IAC1D,gGAAgG;IAChG,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gGAAgG;IAChG,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,6CAA6C;IAC7C,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;;GAEG;AACH;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;;;;GAKG;AACH;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;;AAGA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;;;GAGG;AACH;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,4CAA4C;QAC5C,yBAAyB;;QAEzB;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;;YAEnB;gBACI,aAAa;gBACb,aAAa;YACjB;QACJ;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,MAAM;QACN,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ;uBACmB;AACvB;;AAEA;IACI,YAAY;IACZ;uBACmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;;;;;;;;;;;GAYG;AACH;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iBAAiB;AACjB;;;;;;IAMI,kBAAkB;IAClB,4BAA4B;AAChC;;;;AAIA,iBAAiB;AACjB;;;;;;IAMI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;GAGG;;AAEH;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,oFAAoF;AACpF;;IAEI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,yFAAyF;AACzF;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;;;GAIG;;AAEH,kBAAkB;AAClB;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,6BAA6B;IACjC;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,uCAAuC;IACvC,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA,0FAA0F;AAC1F;;IAEI,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;IACV,wBAAwB;IACxB,yEAAyE;IACzE,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;AACd;;AAEA,yCAAyC;AACzC;;IAEI,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA,6DAA6D;AAC7D;IACI,gFAAgF;AACpF;;AAEA;;IAEI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,iGAAiG;AACrG;;AAEA;IACI,mFAAmF;IACnF,2BAA2B;AAC/B;;AAEA,qFAAqF;AACrF;IACI,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gGAAgG;AACpG;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,wDAAwD;IACxD,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,yGAAyG;AAC7G;;AAEA;IACI,mFAAmF;AACvF;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,MAAM;IACN,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,qDAAqD;IACrD,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,uCAAuC;IACvC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,oDAAoD;IACpD,sCAAsC;AAC1C;;AAEA;IACI,+CAA+C;IAC/C,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,kCAAkC;IAClC,qCAAqC;IACrC,+BAA+B;IAC/B,wCAAwC;IACxC,4BAA4B;IAC5B,+BAA+B;IAC/B,qDAAqD;AACzD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;;IAEI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;;IAEI,cAAc;IACd,uBAAuB;IACvB,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;;IAEI,YAAY;AAChB;;AAEA,sEAAsE;AACtE;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;;;;IAII,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;GAIG;;AAEH;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;;AAElB;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gCAAgC;;IAEhC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,4EAA4E;AAC5E;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;;AAEjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qFAAqF;AACzF;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uDAAuD;AACvD;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uDAAuD;IACvD,uDAAuD;AAC3D;;AAEA;IACI,8DAA8D;AAClE;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,uDAAuD;IACvD,uDAAuD;AAC3D;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,oEAAoE;AACpE;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA,2FAA2F;AAC3F;IACI,eAAe;IACf,MAAM;IACN,uBAAuB;IACvB,uCAAuC;IACvC,4BAA4B;IAC5B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,uBAAuB;IACvB,uCAAuC;IACvC,4BAA4B;IAC5B,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,QAAQ;AACZ;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,4BAA4B;AAChC;;AAEA;;;;IAII,iCAAiC;AACrC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,2EAA2E;AAC3E;;IAEI,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,uDAAuD;IACvD,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,uDAAuD;IACvD,oCAAoC;IACpC,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB,kBAAkB;;AAElB;;IAEI,gBAAgB;;IAEhB,mBAAmB;;IAEnB,cAAc;;AAElB;;AAEA,SAAS;;AAET;;IAEI,SAAO;;AAEX;;AAEA,cAAc;;AAEd;;IAEI,aAAa;;IAEb,mBAAmB;;AAEvB;;AAEA,qBAAqB;;AAErB;;IAEI,aAAa;AACjB;;AAEA,SAAS;;AAET;;IAEI,SAAS;;IAET,WAAW;;IAEX,YAAY;;IAEZ,iBAAiB;;IAEjB,kBAAkB;;IAElB,YAAY;;IAEZ,mBAAmB;;IAEnB,WAAW;;IAEX,eAAe;;IAEf,gBAAgB;;AAEpB;;AAEA,UAAU;;AAEV;;IAEI,iBAAiB;;IAEjB,iBAAiB;;IAEjB,mBAAmB;;IAEnB,yBAAyB;;IAEzB,iBAAiB;;IAEjB,WAAW;;IAEX,eAAe;;IAEf,cAAc;;IAEd,kBAAkB;;IAElB,gBAAgB;;AAEpB;;AAEA,mBAAmB;;AAEnB;;IAEI,aAAa;AACjB;;AAEA,wBAAwB;;AAExB;;IAEI,wBAAwB;;AAE5B;;AAEA,WAAW;;AAEX;;IAEI,cAAc;;IAEd,qBAAqB;;IAErB;;;;wBAIoB;;IAEpB;;yCAEqC;;AAEzC;;AAEA;;IAEI,mBAAmB;;IAEnB,cAAc;;AAElB;;AAEA,WAAW;;AAEX;;IAEI,qBAAqB;;AAEzB;;AAEA,cAAc;;AAEd;;IAEI,WAAW;;IAEX,kBAAkB;;IAElB,QAAQ;;IAER,YAAY;;IAEZ,2BAA2B;;IAE3B,WAAW;;IAEX,YAAY;;IAEZ,6BAA6B;;IAE7B,+BAA+B;;IAE/B,yBAAyB;;AAE7B;;AAEA,UAAU;;AAEV;;IAEI,qBAAqB;;IAErB,cAAc;;AAElB;;AAEA,yEAAyE;AACzE,iGAAiG;AACjG;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,sFAAsF;;AAEtF,wEAAwE;AACxE;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;;IAEI,oFAAoF;IACpF,8EAA8E;IAC9E,gFAAgF;IAChF,wDAAwD;IACxD,2BAA2B;AAC/B;;AAEA;;IAEI;;;gBAGY;IACZ;;;gBAGY;IACZ;;;gBAGY;IACZ,kGAAkG;AACtG;;AAEA;;;;IAII,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;;;;IAII,wBAAwB;AAC5B;;AAEA;;IAEI,oFAAoF;IACpF,8EAA8E;IAC9E,gFAAgF;IAChF,wDAAwD;AAC5D;;AAEA;;IAEI;;;gBAGY;IACZ;;;gBAGY;IACZ;;;gBAGY;IACZ,kGAAkG;AACtG;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,6EAA6E;IAC7E,+EAA+E;IAC/E,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,6EAA6E;IAC7E,+EAA+E;IAC/E,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;;;IAGI,8BAA8B;IAC9B,iDAAiD;IACjD,0CAA0C;AAC9C;;AAEA;;;IAGI,8BAA8B;IAC9B,iDAAiD;IACjD,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,8BAA8B;IAC9B,gCAAgC;IAChC,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;;;IAGI,qCAAqC;AACzC;;AAEA,gEAAgE;AAChE;;;IAGI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB;oEACgE;IAChE,yBAAyB;IACzB,uDAAuD;IACvD,6BAA6B;IAC7B,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA,iHAAiH;AACjH;IACI,mBAAmB;IACnB,qDAAqD;IACrD,iBAAiB;IACjB,qBAAqB;IACrB,8EAA8E;AAClF;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA,0FAA0F;AAC1F;IACI,gGAAgG;IAChG,oEAAoE;IACpE,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;;;IAGI,sBAAsB;IACtB,wEAAwE;IACxE,oEAAoE;AACxE;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,wDAAwD;IACxD,6BAA6B;IAC7B,+CAA+C;IAC/C,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gEAAgE;AAChE;;;;IAII,wCAAwC;IACxC,4BAA4B;IAC5B,uCAAuC;IACvC,oCAAoC;IACpC,uCAAuC;IACvC,gFAAgF;IAChF,wEAAwE;IACxE,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,wDAAwD;AACxD;;;;;;;;;;;;;;IAcI,4DAA4D;IAC5D,kEAAkE;AACtE;;AAEA;;;;;IAKI,4BAA4B;IAC5B,wEAAwE;IACxE,uCAAuC;IACvC,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;;;;IAII,8FAA8F;AAClG;;AAEA;;;;;;;;;;;IAWI,8FAA8F;AAClG;;AAEA;;;;;;;;;;;;;;;IAeI,mHAAmH;IACnH,kHAAkH;AACtH;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,+EAA+E;AAC/E;IACI,oCAAoC;IACpC,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,oDAAoD;IACpD,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;;IAEI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA,yCAAyC;AACzC;IACI,+BAA+B;AACnC;;AAEA,wCAAwC;AACxC;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,yDAAyD;IACzD,6DAA6D;AACjE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,SAAO;IACP,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sDAAsD;IACtD,mDAAmD;IACnD,2CAA2C;IAC3C,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,gBAAgB;IAChB,0DAA0D;IAC1D,yCAAyC;AAC7C;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,sFAAsF;IACtF,mEAAmE;IACnE,yDAAyD;AAC7D;;AAEA;;IAEI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2DAA2D;IAC3D,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;;IAEI,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uDAAuD;AAC3D;;AAEA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,oFAAoF;IACpF,8DAA8D;AAClE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;IACrC,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yDAAyD;IACzD,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,4BAA4B;IAC5B,mBAAmB;IACnB,4DAA4D;IAC5D,qCAAqC;IACrC,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yDAAyD;IACzD,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,WAAW;IACX,mDAAmD;AACvD;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;IACnD,4CAA4C;AAChD;;AAEA;;IAEI,iDAAiD;IACjD,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;IAEI,6EAA6E;AACjF;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wCAAwC;;AAExC;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,gDAAgD;IAChD,gFAAgF;IAChF,uBAAuB;IACvB,8CAA8C;IAC9C,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,oCAAoC;IACpC,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,8EAA8E;IAC9E;;;gBAGY;IACZ,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;;IAEI,wDAAwD;IACxD,sFAAsF;IACtF;;;gBAGY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,gDAAgD;IAChD,wCAAwC;AAC5C;;AAEA;IACI,+CAA+C;IAC/C,uCAAuC;AAC3C;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,0DAA0D;AAC9D;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,0DAA0D;IAC1D,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,oDAAoD;AACxD;;AAEA;IACI,oEAAoE;IACpE,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,0DAA0D;AAC9D;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;AACA;CACC,4BAA4B;AAC7B;AACA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,iDAAiD;IACjD,+CAA+C;AACnD;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,wFAAwF;AAC5F;;AAEA;IACI,6BAA6B;;AAEjC;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;GAEG","sourcesContent":["body {\n    font-size: 12px;\n}\n\n.paginationExtends {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n}\n\n.breadcrumb {\n    padding-bottom: 20px;\n}\n\n.btnAdd {\n    float: right;\n    width: 200px;\n}\n\n.dropDown {\n    width: 100%;\n}\n\n.inlineInput {\n    display: inline;\n}\n\n.actionButton {\n    float: right;\n}\n\n.btnDetails {\n    float: right;\n}\n\n.btnAction {\n    width: 180px;\n}\n\n.btnActionHidden {\n    display: none;\n}\n\n.headerCenter {\n    text-align: center;\n}\n\n.supplier_detail {\n    margin-top: 10px;\n}\n\n.fob article .list_content_action {\n    /* display: flex; */\n    /* margin-bottom: 10px !important; */\n}\n\n.my-group-row {\n    background-color: #0a7c76;\n    font-weight: bold;\n    padding: 5px;\n}\n\n/* Target group rows (assuming group data has a 'group' property) */\n.ant-btn-primary {\n    /* background-color: #1e5f85; */\n    box-shadow: none;\n}\n\n.so-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.article-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.supplier-column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.column-setting {\n    width: 200px;\n    min-height: fit-content;\n    height: auto;\n}\n\n.labelCenter .ant-form-item-label {\n    text-align: center !important;\n}\n\n.labelCenter .ant-form-item-control-input-content {\n    display: flex;\n    justify-content: center;\n}\n\n/* SO style photo upload cards */\n.so-style-photo-upload {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n}\n\n.so-style-photo-upload__cards {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n}\n\n.so-style-photo-card.ant-form-item {\n    margin-bottom: 0;\n    width: 168px;\n}\n\n.so-style-photo-card__shell {\n    width: 168px;\n    border-radius: 16px;\n    overflow: hidden;\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(15, 35, 80, 0.06);\n}\n\n.so-style-photo-card__body {\n    background: var(--so-photo-primary-bg, #eef4ff);\n}\n\n.so-style-photo-card__body .ant-upload-wrapper {\n    display: block;\n}\n\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list {\n    display: block;\n}\n\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-select,\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item-container {\n    width: 168px !important;\n    height: 148px !important;\n    margin: 0 !important;\n}\n\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-select {\n    background: var(--so-photo-primary-bg, #eef4ff) !important;\n    border: 1.5px dashed var(--so-photo-primary-border, var(--so-photo-primary, #3349b3)) !important;\n    border-bottom: none !important;\n    border-radius: 16px 16px 0 0 !important;\n}\n\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item-container {\n    border-radius: 16px 16px 0 0 !important;\n    overflow: hidden;\n}\n\n.so-style-photo-card__body .ant-upload-wrapper .ant-upload-list-item {\n    padding: 0 !important;\n    border: 1.5px dashed var(--so-photo-primary-border, var(--so-photo-primary, #3349b3)) !important;\n    border-bottom: none !important;\n    border-radius: 16px 16px 0 0 !important;\n}\n\n.so-style-photo-card__trigger {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    height: 100%;\n    color: var(--so-photo-primary, #3349b3);\n}\n\n.so-style-photo-card__trigger-icon {\n    font-size: 28px;\n    color: var(--so-photo-primary, #3349b3);\n}\n\n.so-style-photo-card__trigger-text {\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.45);\n    line-height: 1.2;\n}\n\n.so-style-photo-card__footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    padding: 8px 10px;\n    background: var(--so-photo-primary, #3349b3);\n    color: #fff;\n    font-size: 13px;\n    font-weight: 700;\n    text-align: center;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n    line-height: 1.3;\n}\n\n.so-style-photo-upload__note {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 260px;\n    max-width: 100%;\n    padding: 10px 28px;\n    border-radius: 999px;\n    background: #fff;\n    border: 1px solid #e8e8e8;\n    box-shadow: 0 4px 12px rgba(15, 35, 80, 0.08);\n    color: rgba(0, 0, 0, 0.55);\n    font-size: 13px;\n    font-weight: 500;\n    text-align: center;\n}\n\n.so-style-photo-card .ant-form-item-explain {\n    text-align: center;\n    margin-top: 6px;\n}\n\n/* table supplier */\n#tblSupplierList .ant-table-thead th {\n    text-align: center;\n}\n\n/* table article */\n#tbNPL .ant-table-thead th {\n    text-align: center;\n}\n\n/* table master file */\n#tblMF .ant-table-thead th {\n    text-align: center;\n}\n\n/* table invoice */\n#tblSO .ant-table-thead th {\n    text-align: center;\n}\n\n/* table BOM */\n#tblBOM .ant-table-thead th {\n    text-align: center;\n}\n\n#table .ant-table-thead th {\n    text-align: center;\n}\n\n/* column setting for table SO,MF, Category */\n/* #column_setting .ant-form-item-control-input {\n    min-height:fit-content;\n} */\nform#column_setting.ant-form-small .ant-form-item .ant-form-item-control-input {\n    min-height: fit-content !important;\n}\n\n.ant-btn .ant-space.ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small:not(.actionButton) {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* .ant-space-horizontal.ant-space-align-center.ant-space-gap-row-small.ant-space-gap-col-small {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n} */\nbody[data-theme='dark'] .ant-menu-item-selected,\nbody[data-theme='dark'] .ant-menu .ant-menu-item-selected {\n    background-color: #2f4060;\n}\n\nbody[data-theme='dark'] .ant-select-tree-node-selected,\nbody[data-theme='dark'] .ant-tree-select-dropdown .ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {\n    background-color: #2f4060;\n}\n\n\nbody[data-theme='dark'] .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected>.ant-table-cell {\n    background: #2f4060;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n    -moz-appearance: textfield;\n    display: inline;\n    text-align: right;\n    width: 100%;\n}\n\n/* input[type='text'] {\n    display: inline-block;\n    text-align: right;\n} */\n.modal_container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .inner_modal {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n        width: 300px;\n        height: 200px;\n        border-radius: 6px;\n        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);\n        background-color: #ffffff;\n\n        .modal_body {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 65%;\n            padding: 10px;\n        }\n\n        .modal_foot {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            button {\n                padding: 10px;\n                margin: 0 5px;\n            }\n        }\n    }\n\n    .btn_close {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 10px;\n    }\n}\n\n.guard_btn {\n    font-size: 16px;\n    padding: 10px 20px;\n    height: 50px;\n    background-color: #222;\n    color: #b4bed2;\n    border: none;\n}\n\n.dragHandler:hover {\n    cursor: move;\n    /* background-color: #ccc;\n    transition: 0.3s; */\n}\n\nbody[data-theme='dark'] .dragHandler:hover {\n    cursor: move;\n    /* background-color: #2f4060;\n    transition: 0.3s; */\n}\n\n.dragHandler {\n    transition: 0.3s;\n}\n\n.react-resizable {\n    position: relative;\n    background-clip: padding-box;\n}\n\n.react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 100%;\n    bottom: 0;\n    right: -10px;\n    cursor: col-resize;\n    z-index: 1;\n}\n\n@media (max-width: 576px) {\n    .ant-picker-panels {\n        flex-direction: column;\n    }\n}\n\n.tblChart table {\n    font-size: small;\n}\n\n.ant-form-item-required {\n    flex-direction: row-reverse;\n}\n\n.ant-form-item-required::before {\n    margin-left: 4px;\n}\n\n.ant-form-item-required::after {\n    width: 0;\n    margin: 0 !important;\n}\n\nth:has(.dragHandler) {\n    padding: 0px 8px !important;\n}\n\n.searchSpace> :first-child {\n    width: 100%;\n    overflow: hidden;\n}\n\n.pointer-cursor {\n    cursor: pointer;\n}\n\n.fullscreen-light table-wrapper,\n.fullscreen-dark table-wrapper {\n    min-height: 100vh;\n    margin-top: 0;\n}\n\n/* .fullscreen .table-wrapper,\n.fullscreen-light .table-wrapper,\n.fullscreen-dark .table-wrapper {\n    min-height: 100vh;\n    margin-top: 0;\n}\n\n.fullscreen > *:first_child,\n.fullscreen-light > *:first_child,\n.fullscreen-dark > *:first_child {\n    min-height: 100vh;\n    margin-top: 0;\n} */\n.ant-form-item {\n    margin-bottom: 10px;\n}\n\n.hidden-dot {\n    list-style-type: none;\n    margin-top: 10px;\n}\n\n.read.light {\n    background-color: #eee;\n}\n\n.read.light:hover {\n    background-color: white;\n    transition: 0.3s;\n}\n\n.read.dark {\n    background-color: #1b2531;\n}\n\n.read.dark:hover {\n    background-color: #283142;\n    transition: 0.3s;\n}\n\n.bold {\n    font-weight: bold !important;\n}\n\n/* Sửa lỗi font */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: unset;\n    font-weight: bold !important;\n}\n\n\n\n/* Sửa lỗi font */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: unset;\n    font-weight: bold !important;\n}\n\n.checkbox-disabled {\n    background-color: red !important;\n}\n\n/* .ant-table-thead .ant-table-cell {\n    background-color: #1e5f85 !important;\n    color: white !important\n} */\n\n.ant-table-cell-fix-left {\n    overflow-wrap: unset !important;\n}\n\n.small .ant-table-cell {\n    padding: 5px !important;\n    font-size: 0.7rem !important;\n}\n\n.small .ant-select-selector {\n    font-size: 0.7rem !important;\n}\n\n.ant-table-header {\n    text-transform: uppercase;\n}\n\n.fullscreen-action-dark {\n    position: fixed;\n    /* z-index: 2000; */\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    margin: 0;\n    padding: 12px;\n    min-height: 100vh;\n    margin-top: 0;\n    background-color: #1b2531;\n    overflow: auto;\n    box-sizing: border-box;\n}\n\n.fullscreen-action-light {\n    position: fixed;\n    /* z-index: 2000; */\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    margin: 0;\n    padding: 12px;\n    min-height: 100vh;\n    margin-top: 0;\n    background-color: #ffffff;\n    overflow: auto;\n    box-sizing: border-box;\n}\n\n/* Khi vẫn còn nested trong card có stacking context — nâng card lên trên side-nav */\n.ant-main-card:has(.fullscreen-action-light),\n.ant-main-card:has(.fullscreen-action-dark) {\n    /* z-index: 2000 !important; */\n    position: relative;\n}\n\n/* Modal / Drawer overlay — luôn trên side-nav (999) + module menu rail (1000) + header */\n#nagaco-overlay-root,\n#bom-modal-root {\n    position: relative;\n    z-index: 5000;\n}\n\n/* .nagaco-modal-above-layout.ant-modal-root,\n.nagaco-modal-above-layout .ant-modal-mask,\n.nagaco-modal-above-layout .ant-modal-wrap {\n    z-index: 1000 !important;\n} */\n\n/* TreeTable.css */\n.parent-row-light {\n    font-weight: bold;\n    background-color: #fafafa;\n}\n\n.parent-row-dark {\n    font-weight: bold;\n    /* background-color: #1b2531; */\n}\n\nth.ant-descriptions-item-label {\n    width: 180px;\n}\n\n.react-json-view textarea {\n    resize: both\n}\n\n.ant-table-thead {\n    th {\n        text-transform: uppercase;\n        text-align: center !important;\n    }\n}\n\n.nav-item_flex {\n    display: flex;\n    width: 100%;\n}\n\n.nav-item_title {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    display: block;\n}\n\n.board-column {\n    min-width: 250px !important;\n\n}\n\n.orangzition_unit-row {\n    font-weight: 600;\n    padding-bottom: 10px;\n    color: #0a7c76 !important;\n}\n\n/* Chỉ áp dụng cho class cụ thể */\n.custom-height-select .ant-select-selector {\n    height: 35px !important;\n    align-items: center;\n    /* căn giữa text */\n    width: 450px !important;\n}\n\n.ant-select-multiple .ant-select-selector {\n    min-height: 36px;\n    /* chỉnh theo chiều cao bạn muốn */\n    display: flex;\n    align-items: center;\n    /* Căn giữa theo chiều dọc */\n    padding: 4px 8px;\n}\n\n.auto-width {\n    width: auto !important;\n    height: auto !important;\n    padding: 0px !important;\n}\n\n.ant-full-width {\n    width: 100%;\n}\n\n.ant-field-with-button,\n.ant-field-with-button .ant-select-selector {\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n    border-right-width: 0px !important;\n}\n\n.ant-merge-field {\n    display: flex !important;\n    width: 100%;\n}\n\n/* Space.Compact: vạch ngăn giữa các nút primary — trắng, chỉ giữa các nút (không ở đầu) */\n.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(:disabled)::before,\n.nagaco-primary-compact .ant-btn-compact-item.ant-btn-primary:not(:disabled)+.ant-btn-compact-item.ant-btn-primary:not(:disabled)::before {\n    position: absolute;\n    top: -1px;\n    inset-inline-start: -1px;\n    display: inline-block;\n    width: 1px;\n    height: calc(100% + 2px);\n    background-color: var(--nagaco-compact-divider-color, #ffffff) !important;\n    content: '' !important;\n    pointer-events: none;\n    z-index: 1;\n}\n\n/* Không bao giờ vẽ vạch ở nút đầu tiên */\n.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item.ant-btn-compact-first-item::before,\n.nagaco-primary-compact .ant-btn.ant-btn-primary.ant-btn-compact-item.ant-btn-compact-first-item::before {\n    display: none !important;\n    content: none !important;\n    width: 0 !important;\n}\n\n/* Fallback border phải giữa các nút (không đụng cạnh trái) */\n.ant-space-compact .ant-btn.ant-btn-primary.ant-btn-compact-item:not(.ant-btn-compact-last-item):not(:disabled) {\n    border-inline-end-color: var(--nagaco-compact-divider-color, #ffffff) !important;\n}\n\n.ant-merge-field>.ant-space-compact-item:first-child,\n.ant-merge-field>div:first-child {\n    flex: 1;\n    min-width: 0;\n}\n\n.ant-merge-field .ant-select {\n    width: 100%;\n}\n\n.ant-merge-field .ant-prefix-button {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ant-merge-field:not(:hover) .ant-select-selector,\n.ant-merge-field:not(:hover) .ant-input,\n.ant-merge-field:not(:hover) .ant-input-affix-wrapper {\n    border-color: var(--nagaco-merge-field-border-color, var(--ant-color-border, #d9d9d9)) !important;\n}\n\n.ant-merge-field .ant-prefix-button:not(:disabled) {\n    border-color: var(--nagaco-merge-field-button-border-color, transparent) !important;\n    box-shadow: none !important;\n}\n\n/* Space.Compact + select: không vạch giữa combobox và nút + (mặc định transparent) */\n.ant-merge-field.ant-space-compact .ant-prefix-button.ant-btn-compact-item:not(.ant-btn-compact-first-item)::before {\n    display: none !important;\n    content: none !important;\n    width: 0 !important;\n}\n\n.ant-merge-field.ant-space-compact .ant-prefix-button.ant-btn-compact-item:not(.ant-btn-compact-first-item):not(:disabled) {\n    border-inline-start-color: var(--nagaco-merge-field-button-border-color, transparent) !important;\n}\n\n.ant-prefix-button {\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    /* border: solid 1px var(--ant-color-border, #4e5b74); */\n    border-left-width: 0px !important;\n}\n\n.ant-form-item-has-error .ant-prefix-button {\n    border-color: #ff6b72 !important;\n}\n\n.ant-form-item-has-error:hover .ant-prefix-button {\n    border-color: #ff9496 !important;\n}\n\n.ant-select-selector {\n    box-shadow: none !important;\n}\n\n.ant-form-small .ant-merge-field .ant-prefix-button {\n    height: auto;\n}\n\n.ant-form-small .ant-prefix-button {\n    height: 30px;\n}\n\n.ant-form-large .ant-prefix-button {\n    height: 48px;\n}\n\n.ant-form .ant-steps-item-title {\n    font-size: 14px;\n}\n\n.ant-merge-field:hover .ant-select-selector,\n.ant-merge-field:hover .ant-input,\n.ant-merge-field:hover .ant-input-affix-wrapper {\n    border-color: var(--nagaco-merge-field-hover-border, var(--ant-color-primary-border, #6e9cfb)) !important;\n}\n\n.ant-merge-field:hover .ant-prefix-button:not(:disabled) {\n    border-color: var(--nagaco-merge-field-button-border-color, transparent) !important;\n}\n\n.ant-translate-tag {\n    margin: 0px;\n    padding: 0px;\n    list-style-type: none;\n    display: flex;\n    margin-bottom: 5px;\n}\n\n.ant-translate-tag .ant-tag {\n    margin-right: 5px;\n}\n\n.ant-translate-tag li {\n    margin-right: 20px\n}\n\n.ant-dock-pannel {\n    position: absolute;\n    z-index: 100;\n    right: 0;\n    top: 0;\n    height: calc(100% - 33px) !important;\n    margin-top: 34px !important;\n    background-color: #283142;\n    transition: all linear 0.5s;\n    /* box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2); */\n    padding: 20px;\n    overflow-y: auto;\n    /* overflow-x: hidden; */\n    border-left: 1px solid rgb(77, 91, 117);\n    scrollbar-width: none;\n}\n\nbody[data-theme='light'] .ant-dock-pannel {\n    background-color: #ffffff !important;\n    border-color: #e6ebf1;\n    /* box-shadow: -4px 0px 8px rgba(32, 32, 33, 0.2); */\n    /* border-color: #f0f0f0 !important; */\n}\n\n.ant-dock-pannel.expand .ant-btn-group .ant-btn {\n    box-shadow: -5px 5px 8px rgba(76, 78, 100, 0.2);\n    color: #699dff;\n    border-color: #699dff;\n}\n\n.ant-dock-pannel.minimize {\n    width: 0px;\n}\n\n.ant-dock-pannel.minimize.hovered .ant-btn-group,\n.ant-dock-pannel.expand .ant-btn-group {\n    transition: all 0.45s linear 0.05s;\n}\n\n.hover-mask {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 120, 255, 0.1);\n    pointer-events: none;\n}\n\n.ant-dock-pannel .ant-btn-group {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    padding: 0px;\n    z-index: 110;\n    position: fixed;\n    top: 48vh;\n    transform: translateY(-50%);\n    right: 33px;\n    /* border-top-left-radius: 10px; */\n    /* border-bottom-left-radius: 10px; */\n    /* border: 1px solid #1c232f; */\n    /* border-right-width: 0px !important; */\n    transition: all linear 0.45s;\n    /* background-color: #1e5f85; */\n    /* box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2); */\n}\n\n.ant-dock-pannel .ant-btn-group button {\n    box-shadow: -4px 0px 8px rgba(76, 78, 100, 0.2);\n}\n\nbody[data-theme='light'] .ant-btn-group {\n    /* background-color: #ffffff !important; */\n    /* border-color: #f0f0f0 !important; */\n}\n\n.ant-dock-pannel.hovered,\n.ant-dock-pannel.expand {\n    width: 400px;\n    /* margin-left: 20px; */\n}\n\n.ant-dock-pannel .ant-dock-content {\n    display: none;\n    overflow: hidden;\n    height: calc(100% - 34px) !important;\n    overflow-y: scroll;\n    /* margin-top: 34px ! important; */\n}\n\n.ant-dock-pannel.hovered .ant-dock-content,\n.ant-dock-pannel.expand .ant-dock-content {\n    display: block;\n    /* margin-left: 20px; */\n    height: calc(100% - 34px) !important;\n    /* margin-top: 34px ! important; */\n}\n\n.ant-dock-pannel.hovered .ant-btn-group,\n.ant-dock-pannel.expand .ant-btn-group {\n    right: 392px;\n}\n\n/* Inline dock: đặt SAU các rule absolute/fixed để thắng specificity */\n.ant-dock-pannel.ant-dock-pannel--inline {\n    position: relative !important;\n    right: auto !important;\n    top: auto !important;\n    height: auto !important;\n    align-self: stretch;\n    flex-shrink: 0;\n    min-height: 200px;\n    margin-left: 16px;\n}\n\n.ant-dock-pannel.ant-dock-pannel--inline.minimize {\n    width: 24px !important;\n    min-width: 24px;\n    padding: 0 !important;\n    overflow: visible;\n    background: transparent !important;\n    border-left: none !important;\n}\n\n.ant-dock-pannel.ant-dock-pannel--inline .ant-btn-group,\n.ant-dock-pannel.ant-dock-pannel--inline.minimize .ant-btn-group,\n.ant-dock-pannel.ant-dock-pannel--inline.expand .ant-btn-group,\n.ant-dock-pannel.ant-dock-pannel--inline.hovered .ant-btn-group {\n    position: absolute !important;\n    right: auto !important;\n    left: 0 !important;\n    top: 48% !important;\n    transform: translateY(-50%);\n}\n\n.ant-btn-group .break::after {\n    content: \"\";\n    display: block;\n    /* width: 45px; */\n    height: 1px;\n    background-color: #4d5b75;\n}\n\n.ant-btn-group button {\n    height: 50px;\n}\n\n/* \nbody[data-theme='light'] .ant-btn-group .break::after {\n    \n    background-color: #1e5f85;\n} */\n\n.timeline-approval-history .ant-timeline.ant-timeline-label .ant-timeline-item-label {\n    position: unset;\n}\n\n.timeline-approval-history .ant-timeline .ant-timeline-item-content {\n    margin-top: -40px;\n}\n\n.timeline-approval-history .ant-timeline.ant-timeline-label .ant-timeline-item-head {\n    top: 10px;\n}\n\n.ant-select-selection-overflow-item {\n    margin-right: 10px\n}\n\n.ant-descriptions-collapse {\n    max-height: 1000px;\n    overflow-y: auto;\n    transition: all 0.5s ease;\n}\n\n.ant-descriptions-collapse.ant-descriptions-hidden {\n    overflow: hidden;\n    max-height: 0px\n}\n\n.ant-fullwidth {\n    width: 100%;\n}\n\n.ant-fullheight {\n    height: 100%;\n}\n\n.ant-input-number-sm .ant-input-number-input {\n    height: 30px !important;\n}\n\n#form_filter .ant-form-item {\n    margin-bottom: 4px !important;\n}\n\n.ant-btn-color-dangerous {\n    box-shadow: unset;\n}\n\n.dashboard-item {\n    /* border-radius: 10px; */\n    background-color: #fbfcfc;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: opacity linear 0.5s;\n    position: relative;\n    overflow: hidden;\n}\n\n.dashboard-item .dashboard-add {\n    opacity: 0.1;\n    transition: opacity linear 0.5s;\n    font-size: 16\n}\n\n.dashboard-item:hover .dashboard-add {\n    opacity: 0.8;\n}\n\n.dashboard-item:hover {\n    background-color: #f4f5f5;\n}\n\nbody[data-theme='dark'] .dashboard-item,\nbody[data-theme='dark'] .screen .screen-header {\n    background-color: #2b3445;\n    border-color: #1c232f;\n}\n\nbody[data-theme='dark'] .screen {\n    background-color: #283142;\n    border-color: #1c232f;\n}\n\nbody[data-theme='dark'] .dashboard-item:hover {\n    background-color: #30394b;\n}\n\nbody[data-theme='dark'] .text-muted-foreground {\n    color: #8892a4\n}\n\n.screen {\n    border-radius: 10px;\n    border: 1px solid #b4b4b5;\n    background: #fbfcfc;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 8px 32px rgba(0, 0, 0, 0.06),\n}\n\n.flex {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.screen .screen-header {\n    height: 38px;\n    border-bottom: solid 1px #b4b4b5;\n    background: #f4f5f5;\n    padding: 0px 16px\n}\n\n.screen .screen-header .screen-header__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 8px;\n}\n\n.text-muted-foreground {\n    line-height: normal;\n    color: #6b7280;\n}\n\n.overflow-auto {\n    overflow: auto;\n}\n\n.flex-center {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n\n.action-pannel {\n    width: 250px;\n    height: calc(100% - 70px);\n    background-color: #fbfcfc;\n    border-left: solid 1px #e6ebf1;\n    position: fixed;\n    right: 0px;\n    top: 70px;\n    overflow: auto;\n}\n\n.design-pannel {\n    width: calc(100% - 250px);\n    overflow: auto;\n}\n\n.design-grid {\n    height: calc(100vh - 280px);\n}\n\nbody[data-theme='dark'] .action-pannel,\nbody[data-theme='dark'] .template-card {\n    border-color: #1c232f;\n    background-color: #283142;\n}\n\nbody[data-theme='dark'] .template-card {\n    border-color: #4d5b75;\n}\n\n#dashboard-action-tab .ant-tabs-nav-list {\n    width: 100%;\n    display: flex;\n}\n\n#dashboard-action-tab .ant-tabs-nav-list .ant-tabs-tab {\n    flex: 1;\n    justify-content: center;\n    margin: 0px;\n}\n\n#dashboard-action-tab .ant-tabs-ink-bar {\n    width: 50%;\n}\n\n.template-card {\n    background-color: #fbfcfc;\n    border: solid 1px #e6ebf1;\n    opacity: 1;\n    transform: scale(1);\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 3px;\n}\n\n.flex-1 {\n    flex: 1\n}\n\n.relative {\n    position: relative\n}\n\n.flex-col {\n    flex-direction: column;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.gap-1 {\n    gap: 1px;\n}\n\n.gap-2 {\n    gap: 2px;\n}\n\n.gap-5 {\n    gap: 5px;\n}\n\n\n.rounded {\n    border-radius: 4px;\n}\n\n.align-start {\n    align-items: flex-start;\n}\n\n.align-end {\n    align-items: flex-end;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.absolute {\n    position: absolute;\n}\n\n.template-screen {}\n\n.template-screen:hover .template-action {\n    opacity: 1;\n}\n\n.template-action {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    transition: opacity ease 0.5s;\n    justify-content: center;\n    align-items: center;\n}\n\n.template-action button {\n\n    /* cursor: pointer; */\n    cursor: pointer\n}\n\n.rounded-md {\n    border-radius: 4px;\n}\n\n.rounded-full {\n    border-radius: 50%;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.widget-card {\n    background-color: #fbfcfc;\n    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 3px;\n    cursor: pointer;\n}\n\n.widget-header {\n    height: 36px;\n    border-bottom: solid 1px #e6ebf1;\n    ;\n    background: transparent;\n}\n\n.widget-body {\n    height: calc(100% - 36px);\n    display: flex;\n}\n\n.widget-card--no-header .widget-body,\n.widget-body.widget-body--full {\n    height: 100%;\n}\n\n.widget-body-inner--flush {\n    height: 100%;\n    width: 100%;\n}\n\n/* Mobile / stack: avoid % height collapse when parent only has min-height */\n.widget-body.widget-body-stack {\n    flex: 1 1 auto;\n    height: auto;\n    min-height: 140px;\n    overflow: visible;\n}\n\n.widget-card.widget-card-stack {\n    min-height: 100%;\n    height: 100%;\n}\n\n.dashboard-layout-stack-item .dashboard-widget,\n.dashboard-layout-responsive-item .dashboard-widget {\n    height: 100%;\n}\n\nbody[data-theme='dark'] .widget-card {\n    border-color: #1c232f;\n    background-color: #283142;\n}\n\nbody[data-theme='dark'] .widget-header,\nbody[data-theme='dark'] .dashboard-widget {\n    border-color: #1c232f;\n}\n\n.widget-header .lucide {\n    opacity: 0.4;\n    transition: opacity ease 0.5s;\n}\n\n.widget-header:hover .lucide {\n    opacity: 1;\n}\n\n.widget-header .widget-category {\n    background-color: #d8d8d8;\n\n}\n\nbody[data-theme='dark'] .widget-header .widget-category {\n    background-color: #4d5b75;\n}\n\n.library_category {\n    overflow-y: scroll;\n\n}\n\n.library_category .ant-collapse-content-box {\n    padding: 6px !important;\n    padding-block: 4px !important;\n\n}\n\n.action-pannel .ant-tabs-content {\n    height: 100% !important;\n}\n\n.scroll-hidden {\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n}\n\n.scroll-hidden::-webkit-scrollbar {\n    display: none;\n}\n\n.library_category .ant-collapse-expand-icon {\n    padding-inline-start: 4px !important;\n    margin-inline-start: 0px !important;\n}\n\n.dashboard-widget {\n    transition: all ease 0.2s;\n    border: solid 1px #e6ebf1;\n}\n\n.widget-active {\n    border: 2px solid #3e79f7 !important;\n    box-shadow: rgba(37, 99, 235, 0.15) 0px 0px 0px 3px, rgba(0, 0, 0, 0.12) 0px 4px 16px;\n}\n\n.widget-active .widget-conner {\n    background: #3e79f7;\n}\n\n/* ASM Dashboard — theme-aware layout & widget chrome */\n.asm-dashboard {\n    min-height: 0;\n}\n\n.asm-dashboard__content {\n    min-height: 0;\n}\n\n.asm-dashboard--nationalDay .widget-card {\n    background-color: var(--asm-dashboard-card-bg, #ffffff);\n    border-color: var(--asm-dashboard-card-border, #e8dcc8);\n}\n\n.asm-dashboard--nationalDay .widget-header {\n    border-bottom-color: var(--asm-dashboard-card-border, #e8dcc8);\n}\n\n.asm-dashboard--nationalDay .widget-header .truncate.text-foreground,\n.asm-dashboard--nationalDay .widget-header span.truncate {\n    color: var(--asm-dashboard-primary, #9f0000);\n}\n\n.asm-dashboard--nationalDay .widget-header .widget-category {\n    background-color: #ffc466;\n    color: var(--asm-dashboard-primary, #9f0000);\n}\n\n.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-card {\n    background-color: var(--asm-dashboard-card-bg, #ffffff);\n    border-color: var(--asm-dashboard-card-border, #e8dcc8);\n}\n\n.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header .truncate.text-foreground,\n.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header span.truncate {\n    color: var(--asm-dashboard-primary);\n}\n\n.asm-dashboard:not(.asm-dashboard--light):not(.asm-dashboard--dark) .widget-header .widget-category {\n    background-color: #ffc466;\n    color: var(--asm-dashboard-primary);\n}\n\n.absolute {\n    position: absolute;\n}\n\n.top-0 {\n    top: 0px;\n}\n\n.bottom-0 {\n    bottom: 0px;\n}\n\n.left-0 {\n    left: 0px;\n}\n\n.right-0 {\n    right: 0px;\n}\n\n.cursor-se-resize {\n    cursor: se-resize;\n}\n\n.cursor-ne-resize {\n    cursor: ne-resize;\n}\n\n.scroll-track-y,\n.scroll-thumb-y {\n    width: 6px !important;\n}\n\n.custom-scrollbar .scroll-track-y {\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    pointer-events: none;\n}\n\n.custom-scrollbar:hover .scroll-track-y {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.custom-scrollbar .ScrollbarsCustom-Wrapper {\n    inset: 0px !important;\n}\n\n.ant-layout {\n    position: relative;\n    /* z-index: 1000; */\n}\n\n.ant-modal-root {\n    position: relative;\n    /* z-index: 2000; */\n}\n\n.theme-effects-layer {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 1100;\n    overflow: hidden;\n}\n\n.theme-effects-layer canvas {\n    pointer-events: none !important;\n}\n\n/* Banner 2/9 — ghim góc phải; bottom lấy từ inline style (vd. 55) */\n.theme-effects-layer .national-day-footer-pin {\n    position: absolute !important;\n    right: 0 !important;\n    left: auto !important;\n    top: auto !important;\n}\n\n/* 20/10 — banner nổi trên header (z > 1000); pointer-events: none để vẫn bấm search/icon */\n.women-day-header-banner {\n    position: fixed;\n    top: 0;\n    left: calc(50% + 150px);\n    transform: translateX(-50%) scale(0.72);\n    transform-origin: center top;\n    width: min(720px, calc(100vw - 360px));\n    height: auto;\n    max-height: 120px;\n    object-fit: contain;\n    object-position: center top;\n    pointer-events: none;\n    z-index: 1001;\n}\n\n.culture-day-header-banner {\n    position: fixed;\n    top: 5px;\n    left: calc(50% + 150px);\n    transform: translateX(-50%) scale(0.72);\n    transform-origin: center top;\n    width: min(720px, calc(100vw - 360px));\n    height: auto;\n    max-height: 100px;\n    object-fit: contain;\n    object-position: center top;\n    pointer-events: none;\n    z-index: 1001;\n}\n\n.side-nav-theme-bg {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.side-nav-theme-bg-image {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: bottom center;\n    background-size: contain;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.side-nav-scroll {\n    position: relative;\n    z-index: 1;\n    flex: 1;\n    min-height: 0;\n    height: 100%;\n}\n\n.side-nav-scroll>div,\n.side-nav-menu-wrapper {\n    height: 100%;\n}\n\n.tet-branch-left {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 260px;\n    z-index: 12;\n    pointer-events: none;\n}\n\n.tet-branch-right {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 260px;\n    z-index: 12;\n    pointer-events: none;\n}\n\n.national-day-branch-left {\n    position: fixed;\n    top: 0;\n    left: 168px;\n    width: auto;\n    max-width: 110px;\n    max-height: 85px;\n    height: auto;\n    object-fit: contain;\n    object-position: left top;\n    z-index: 1001;\n    pointer-events: none;\n}\n\n.theme-logo-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    text-decoration: none;\n}\n\n.theme-logo-image {\n    width: 65%;\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n.theme-footer-logo {\n    height: 20px;\n    width: auto;\n    vertical-align: middle;\n    margin-inline: 0 4px;\n    object-fit: contain;\n}\n\n.theme-logo-badge {\n    width: 18px;\n    height: auto;\n    flex-shrink: 0;\n    object-fit: contain;\n}\n\n.theme-logo-decoration {\n    position: fixed;\n    top: 0;\n    left: 168px;\n    width: auto;\n    max-width: 110px;\n    max-height: 85px;\n    height: auto;\n    object-fit: contain;\n    object-position: left top;\n    z-index: 1001;\n    pointer-events: none;\n}\n\n.theme-logo-decoration--tet {\n    max-width: 96px;\n    max-height: 72px;\n}\n\n.theme-logo-decoration--women-day {\n    max-width: 88px;\n    max-height: 68px;\n}\n\n.theme-logo-decoration--noel {\n    max-width: 120px;\n    max-height: 90px;\n}\n\n.theme-logo-decoration--culture-day {\n    left: calc(168px + 16px);\n    top: 5px;\n}\n\n.custom-menu .ant-menu-item-icon,\n.custom-menu .anticon {\n    width: 20px;\n    min-width: 20px;\n    margin-right: 8px !important;\n}\n\n.custom-menu .ant-menu-item .ant-menu-item-icon,\n.custom-menu .ant-menu-submenu-title .ant-menu-item-icon,\n.custom-menu .ant-menu-item .anticon,\n.custom-menu .ant-menu-submenu-title .anticon {\n    margin-inline-end: 0px !important;\n}\n\n.ant-menu-item,\n.ant-menu-submenu-title {\n    display: flex !important;\n}\n\n/* Custom Tabs — nagaco-custom-tabs / erp-tabs (folder-style, mockup ERP) */\n.nagaco-custom-tabs,\n.erp-tabs {\n    --nagaco-tab-gap: 12px;\n    --nagaco-tab-padding-x: 14px;\n    --nagaco-tab-radius: 14px;\n    --nagaco-tab-arch: 26px;\n    --nagaco-tab-valley: 7px;\n    --nagaco-tab-border-width: 1px;\n    --nagaco-tab-border: #d4d4d4;\n    --nagaco-tab-nav-bg: #f0f0f0;\n    --nagaco-tab-primary: var(--ant-color-primary, #1677ff);\n    overflow: visible;\n}\n\n/* ── Nav bar ── */\n.nagaco-custom-tabs__nav {\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: nowrap;\n    margin: 0;\n    padding: 10px 12px calc(var(--nagaco-tab-valley) + 4px);\n    background: var(--nagaco-tab-nav-bg);\n    border-radius: 10px 10px 0 0;\n    overflow: visible;\n}\n\n/* ── Tab item ── */\n/* toàn bộ thanh */\n\n.wizard-step {\n\n    overflow-x: auto;\n\n    white-space: nowrap;\n\n    padding: 8px 0;\n\n}\n\n/* step */\n\n.wizard-step .ant-steps-item {\n\n    flex: 1;\n\n}\n\n/* container */\n\n.wizard-step .ant-steps-item-container {\n\n    display: flex;\n\n    align-items: center;\n\n}\n\n/* bỏ line mặc định */\n\n.wizard-step .ant-steps-item-tail {\n\n    display: none;\n}\n\n/* icon */\n\n.wizard-step .ant-steps-item-icon {\n\n    margin: 0;\n\n    width: 28px;\n\n    height: 28px;\n\n    line-height: 28px;\n\n    border-radius: 50%;\n\n    border: none;\n\n    background: #ececec;\n\n    color: #666;\n\n    font-size: 14px;\n\n    transition: .25s;\n\n}\n\n/* title */\n\n.wizard-step .ant-steps-item-title {\n\n    margin-left: 10px;\n\n    padding: 8px 22px;\n\n    border-radius: 28px;\n\n    border: 1px solid #bfbfbf;\n\n    background: white;\n\n    color: #666;\n\n    font-size: 15px;\n\n    line-height: 1;\n\n    position: relative;\n\n    transition: .25s;\n\n}\n\n/* ẩn description */\n\n.wizard-step .ant-steps-item-description {\n\n    display: none;\n}\n\n/* bỏ ::after mặc định */\n\n.wizard-step .ant-steps-item-title::after {\n\n    display: none !important;\n\n}\n\n/* active */\n\n.wizard-step .ant-steps-item-process .ant-steps-item-title {\n\n    color: #1677ff;\n\n    border-color: #1677ff;\n\n    background:\n\n        linear-gradient(to bottom,\n            #dcebff,\n            #ffffff 55%);\n\n    box-shadow:\n\n        0 2px 8px rgba(22, 119, 255, .15);\n\n}\n\n.wizard-step .ant-steps-item-process .ant-steps-item-icon {\n\n    background: #dcebff;\n\n    color: #1677ff;\n\n}\n\n/* finish */\n\n.wizard-step .ant-steps-item-finish .ant-steps-item-title {\n\n    border-color: #91caff;\n\n}\n\n/* connector */\n\n.wizard-step .ant-steps-item:not(:last-child) .ant-steps-item-title::before {\n\n    content: \"\";\n\n    position: absolute;\n\n    top: 50%;\n\n    right: -18px;\n\n    transform: translateY(-50%);\n\n    width: 20px;\n\n    height: 20px;\n\n    border-top: 3px solid #1677ff;\n\n    border-right: 3px solid #1677ff;\n\n    border-radius: 0 20px 0 0;\n\n}\n\n/* hover */\n\n.wizard-step .ant-steps-item:hover .ant-steps-item-title {\n\n    border-color: #1677ff;\n\n    color: #1677ff;\n\n}\n\n/* Striped rows — chỉ áp dụng theme light; dark giữ mặc định Ant Design */\n/* :not(.nagaco-comment-cell) để không đè màu nền báo lỗi/thành công của cột \"notes\" khi import */\nbody[data-theme='light'] .ant-table-row.table-row-light>.ant-table-cell:not(.nagaco-comment-cell),\nbody[data-theme='light'] .table-row-light>td:not(.nagaco-comment-cell) {\n    background: #ffffff !important;\n}\n\nbody[data-theme='light'] .ant-table-row.table-row-dark>.ant-table-cell:not(.nagaco-comment-cell),\nbody[data-theme='light'] .table-row-dark>td:not(.nagaco-comment-cell) {\n    background: #f5f5f5 !important;\n}\n\n/* Striped rows hover/selected — lightTheme.js lightScopedStyles (theo colorPrimary) */\n\n/* Purchase group form card — taller header, title vertically centered */\n.purchase-group-form-card>.ant-card-head {\n    height: 54px !important;\n    min-height: 50px !important;\n    padding: 0 16px !important;\n    border-bottom: none;\n    display: flex;\n    align-items: center;\n}\n\n.purchase-group-form-card>.ant-card-head .ant-card-head-wrapper {\n    width: 100%;\n    height: 100%;\n    min-height: 50px;\n    display: flex;\n    align-items: center;\n}\n\n.purchase-group-form-card>.ant-card-head .ant-card-head-title {\n    padding: 0 !important;\n    margin: 0 !important;\n    line-height: 1.4;\n    display: flex;\n    align-items: center;\n}\n\n/* Detail card header — title + pill action groups */\n.detail-card-with-action-header>.ant-card-head {\n    border-bottom: none;\n    min-height: auto !important;\n    padding: 6px 16px !important;\n}\n\n.detail-card-with-action-header>.ant-card-head .ant-card-head-wrapper {\n    min-height: auto;\n    padding: 0;\n}\n\n.detail-card-with-action-header>.ant-card-head .ant-card-head-title {\n    padding: 0;\n    min-height: auto;\n    line-height: 1;\n}\n\n.detail-card-with-action-header>.ant-card-head .ant-card-extra {\n    padding: 0 !important;\n    margin-inline-start: 12px;\n    display: inline-flex;\n    align-items: center;\n    align-self: center;\n}\n\n.detail-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    min-width: 0;\n    min-height: 38px;\n}\n\n.detail-card-header-title {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    color: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    line-height: 1.4;\n}\n\n.detail-card-header-chevron {\n    flex-shrink: 0;\n    font-size: 12px;\n    opacity: 0.95;\n}\n\n.detail-action-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.detail-action-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 6px;\n    background: #fff;\n    border-radius: 999px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.detail-action-pill .ant-tooltip-disabled-compatible-wrapper {\n    display: inline-flex;\n    line-height: 0;\n}\n\n.ant-btn.detail-back-btn.ant-btn-primary,\nbutton.ant-btn.detail-back-btn.ant-btn-primary {\n    background-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    background: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    border-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    color: var(--detail-theme-action-color, #fff) !important;\n    box-shadow: none !important;\n}\n\n.ant-btn.detail-back-btn--in-card.ant-btn-primary,\nbutton.ant-btn.detail-back-btn--in-card.ant-btn-primary {\n    background-color: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    background: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    border-color: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    color: var(--detail-theme-action-in-card-color, var(--detail-theme-action-color, #fff)) !important;\n}\n\n.ant-btn.detail-back-btn.ant-btn-primary .anticon,\n.ant-btn.detail-back-btn.ant-btn-primary .anticon svg,\n.ant-btn.detail-back-btn--in-card.ant-btn-primary .anticon,\n.ant-btn.detail-back-btn--in-card.ant-btn-primary .anticon svg {\n    color: inherit !important;\n    fill: currentColor !important;\n}\n\n.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):hover,\n.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):focus,\n.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):hover,\n.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):focus {\n    filter: brightness(1.08);\n}\n\n.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):hover,\n.ant-btn.detail-back-btn.ant-btn-primary:not(:disabled):focus {\n    background-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    background: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    border-color: var(--detail-theme-action-bg, var(--ant-color-primary)) !important;\n    color: var(--detail-theme-action-color, #fff) !important;\n}\n\n.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):hover,\n.ant-btn.detail-back-btn--in-card.ant-btn-primary:not(:disabled):focus {\n    background-color: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    background: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    border-color: var(\n        --detail-theme-action-in-card-bg,\n        var(--detail-theme-action-bg, var(--ant-color-primary))\n    ) !important;\n    color: var(--detail-theme-action-in-card-color, var(--detail-theme-action-color, #fff)) !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    padding: 0;\n    border-width: 1.5px;\n    box-shadow: none !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn .anticon {\n    font-size: 14px;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-default {\n    background: var(--detail-action-primary, var(--ant-color-primary)) !important;\n    border-color: var(--detail-action-primary, var(--ant-color-primary)) !important;\n    color: #ffffff !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn .anticon,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary .anticon {\n    color: #ffffff !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn:not(:disabled):hover,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-primary:not(:disabled):hover,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--filled.ant-btn-default:not(:disabled):hover {\n    background: var(--detail-action-primary, var(--ant-color-primary)) !important;\n    border-color: var(--detail-action-primary, var(--ant-color-primary)) !important;\n    color: #ffffff !important;\n    filter: brightness(1.08);\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-default,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-primary {\n    background: #ffffff !important;\n    border-color: var(--ant-color-primary) !important;\n    color: var(--ant-color-primary) !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn:not(:disabled):hover,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-default:not(:disabled):hover,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--outline.ant-btn-primary:not(:disabled):hover {\n    background: #ffffff !important;\n    border-color: var(--ant-color-primary) !important;\n    color: var(--ant-color-primary) !important;\n    opacity: 0.85;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default {\n    background: #ff4d4f !important;\n    border-color: #ff4d4f !important;\n    color: #ffffff !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:not(:disabled):hover,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:not(:disabled):hover {\n    background: #ff7875 !important;\n    border-color: #ff7875 !important;\n    color: #ffffff !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn .anticon,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default .anticon {\n    color: #ffffff !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn:disabled,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-default:disabled,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-primary:disabled {\n    background: #f5f5f5 !important;\n    border-color: #d9d9d9 !important;\n    color: rgba(0, 0, 0, 0.45) !important;\n    opacity: 1 !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn:disabled .anticon,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-default:disabled .anticon,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn.ant-btn-primary:disabled .anticon {\n    color: rgba(0, 0, 0, 0.45) !important;\n}\n\n/* Delete disabled: keep danger cue but readable on light pill */\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:disabled,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:disabled,\n.detail-card-with-action-header .detail-action-pill #delete_record.ant-btn:disabled {\n    background: #fff1f0 !important;\n    border-color: #ffa39e !important;\n    color: #cf1322 !important;\n    opacity: 1 !important;\n}\n\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn:disabled .anticon,\n.detail-card-with-action-header .detail-action-pill .detail-action-btn--danger.ant-btn-default:disabled .anticon,\n.detail-card-with-action-header .detail-action-pill #delete_record.ant-btn:disabled .anticon {\n    color: #cf1322 !important;\n}\n\n.side-nav-module-menu-rail .ant-menu-item>span {\n    display: block !important;\n}\n\n.truncate {\n    text-wrap: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.text-right .ant-input-number-input {\n    text-align: right;\n}\n\n.text-black .ant-input-number-input {\n    color: #455560;\n}\n\n.ant-main-card {\n    border-radius: 22px;\n    /* Không set z-index ở đây — sẽ tạo stacking context khiến\n       .fullscreen-action-* (position:fixed) bị side-nav/header đè */\n    border: 1px solid #d9e6ff;\n    border-top: 4px solid var(--ant-color-primary, #1677ff);\n    border-width: 3px 0px 0px 0px;\n    box-shadow: 0 4px 16px rgba(51, 75, 196, 0.08);\n    margin-bottom: 16px;\n}\n\n/* Dashboard module cards — viền đủ 4 cạnh + top accent (dark: accent #0052AD, không dùng colorPrimary #1b2531) */\n.ant-main-card.dashboard-module-card {\n    border-style: solid;\n    border-color: var(--module-card-side-border, #d9e6ff);\n    border-width: 1px;\n    border-top-width: 3px;\n    border-top-color: var(--module-card-accent, var(--ant-color-primary, #1677ff));\n}\n\nbody[data-theme='dark'] .ant-main-card.dashboard-module-card {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);\n}\n\n.ant-main-card .ant-card-body {\n    height: 100%;\n}\n\n/* Dashboard module card — «Mở phân hệ» (dark: trắng + accent; hover/active: nền accent) */\n.module-card-open-module-btn.ant-btn-default:not(:disabled) {\n    color: var(--module-card-open-btn-label, var(--module-card-open-btn-accent, #1677ff)) !important;\n    border-color: var(--module-card-open-btn-accent, #1677ff) !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n}\n\n.module-card-open-module-btn.ant-btn-default:not(:disabled):hover,\n.module-card-open-module-btn.ant-btn-default:not(:disabled):active,\n.module-card-open-module-btn.ant-btn-default:not(:disabled):focus-visible {\n    color: #fff !important;\n    background-color: var(--module-card-open-btn-accent, #1677ff) !important;\n    border-color: var(--module-card-open-btn-accent, #1677ff) !important;\n}\n\n.module-card-open-module-btn--dark.ant-btn-default:not(:disabled):active {\n    filter: brightness(1.12);\n}\n\n.module-card-open-module-btn.ant-btn-default:not(:disabled) .ant-btn-icon,\n.module-card-open-module-btn.ant-btn-default:not(:disabled) svg {\n    color: inherit;\n}\n\n.ant-left-card {\n    border-radius: 22px;\n    position: 'sticky';\n    bottom: 0;\n    z-index: 100;\n    border: 1px solid #d9e6ff;\n    border-left: 4px solid var(--ant-color-primary, #1677ff);\n    border-width: 0px 0px 0px 3px;\n    box-shadow: 0 -8px 24px rgba(51, 75, 196, 0.12);\n    /* margin: 18px; */\n}\n\n\n.breadcrumb-container {\n    /* padding: 6px 18px; */\n    margin: -16px -16px 16px -16px;\n    padding: 6px 16px;\n}\n\n.variable-row>span>span:nth-child(2) {\n    color: var(--rmg-gray-400, gray) !important;\n}\n\n.object-key {\n    color: var(--ant-color-primary, #1677ff) !important;\n}\n\n.variable-editor {\n    background-color: white !important;\n}\n\n.ant-menu-item-group-title {\n    padding-left: 15px !important;\n}\n\n/* custom-menu selected chrome — không áp lên module-menu rail */\n.custom-menu .ant-menu-item-selected,\n.custom-menu-popup .ant-menu-item-selected,\n.ant-menu-submenu-popup .ant-menu-item-selected,\n.ant-menu-submenu-selected>.ant-menu-submenu-title {\n    /* transition: all 1s ease !important; */\n    margin-left: 15px !important;\n    border-radius: 0 24px 24px 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    /* Phải set màu tường minh — thiếu màu sẽ ăn currentColor (chữ tối → vạch đen) */\n    border-left: 5px solid var(--nagaco-menu-active-bar, #ffd700) !important;\n    box-shadow: none !important;\n    width: calc(100% - 24px) !important;\n}\n\n/* custom-menu / popup — không áp lên module-menu rail */\n.custom-menu .ant-menu-item-selected,\n.custom-menu-popup .ant-menu-item-selected,\n.ant-menu-submenu-popup .ant-menu-item-selected,\n.ant-menu-submenu-selected>.ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-submenu-selected>.ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-submenu-active>.ant-menu-submenu-title,\n.ant-menu-popup .ant-menu-submenu-selected>.ant-menu-submenu-title,\n.ant-menu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed .ant-menu-submenu-selected>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed .ant-menu-submenu-open>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed .ant-menu-submenu-active>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed.ant-menu .ant-menu-submenu-selected>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed.ant-menu .ant-menu-submenu-open>.ant-menu-submenu-title {\n    background: var(--nagaco-menu-active-bg, #fff8ed) !important;\n    background-color: var(--nagaco-menu-active-bg, #fff8ed) !important;\n}\n\n.ant-menu-submenu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,\n.ant-menu-submenu-popup .ant-menu-submenu-active>.ant-menu-submenu-title,\n.ant-menu-popup .ant-menu-submenu-open>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed .ant-menu-submenu-open>.ant-menu-submenu-title,\n.custom-menu-popup-collapsed .ant-menu-submenu-active>.ant-menu-submenu-title {\n    margin-left: 15px !important;\n    border-left: 5px solid var(--nagaco-menu-active-bar, #ffd700) !important;\n    border-radius: 0 24px 24px 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n    box-shadow: none !important;\n    width: calc(100% - 24px) !important;\n}\n\n.custom-menu .ant-menu-item-selected,\n.custom-menu-popup .ant-menu-item-selected,\n.ant-menu-submenu-popup .ant-menu-item-selected,\n.ant-menu-submenu-selected > .ant-menu-submenu-title {\n    color: var(--nagaco-menu-active-text, var(--ant-menu-item-selected-color, inherit)) !important;\n}\n\n.custom-menu .ant-menu-item-selected .ant-menu-title-content,\n.custom-menu .ant-menu-item-selected .nav-item_title,\n.custom-menu .ant-menu-item-selected .nav-item_flex,\n.custom-menu .ant-menu-item-selected .nav-item_flex span,\n.custom-menu-popup .ant-menu-item-selected .ant-menu-title-content,\n.custom-menu-popup .ant-menu-item-selected .nav-item_title,\n.ant-menu-submenu-popup .ant-menu-item-selected .ant-menu-title-content,\n.ant-menu-submenu-popup .ant-menu-item-selected .nav-item_title,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-title-content,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .nav-item_title,\n.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .nav-item_title {\n    color: var(--nagaco-menu-active-text, var(--ant-menu-item-selected-color, inherit)) !important;\n}\n\n.custom-menu .ant-menu-item-selected .ant-menu-item-icon,\n.custom-menu .ant-menu-item-selected .ant-menu-item-icon .anticon,\n.custom-menu .ant-menu-item-selected .anticon,\n.custom-menu .ant-menu-item-selected .anticon svg,\n.custom-menu-popup .ant-menu-item-selected .ant-menu-item-icon,\n.custom-menu-popup .ant-menu-item-selected .anticon,\n.ant-menu-submenu-popup .ant-menu-item-selected .ant-menu-item-icon,\n.ant-menu-submenu-popup .ant-menu-item-selected .anticon,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .anticon svg,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-expand-icon,\n.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-expand-icon .anticon,\n.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-item-icon,\n.ant-menu-submenu-popup .ant-menu-submenu-open > .ant-menu-submenu-title .anticon {\n    color: var(--nagaco-menu-active-icon, var(--nagaco-menu-active-text, var(--ant-color-primary, #9f0000))) !important;\n    fill: var(--nagaco-menu-active-icon, var(--nagaco-menu-active-text, var(--ant-color-primary, #9f0000))) !important;\n}\n\n.ant-card .ant-card-body {\n    padding: 15px 20px;\n}\n\n.ant-tooltip-inner {\n    min-height: unset !important;\n}\n\n/* Simplify / Detailed switch — white text on primary header, clear of handle */\n.nagaco-simplify-switch.ant-switch {\n    background: rgba(255, 255, 255, 0.2);\n    min-width: 96px;\n    height: 26px;\n    line-height: 26px;\n}\n\n.nagaco-simplify-switch.ant-switch.ant-switch-checked {\n    background: rgba(255, 255, 255, 0.32);\n}\n\n.nagaco-simplify-switch.ant-switch .ant-switch-inner {\n    display: block !important;\n    position: relative;\n    height: 26px !important;\n    line-height: 26px !important;\n    font-size: 13px !important;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    /* Unchecked: handle on the left — push text right */\n    padding-inline-start: 28px !important;\n    padding-inline-end: 8px !important;\n}\n\n.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-inner {\n    /* Checked: handle on the right — push text left */\n    padding-inline-start: 8px !important;\n    padding-inline-end: 28px !important;\n}\n\n.nagaco-simplify-switch.ant-switch .ant-switch-inner-checked,\n.nagaco-simplify-switch.ant-switch .ant-switch-inner-unchecked {\n    display: none !important;\n    align-items: center !important;\n    justify-content: center !important;\n    height: 26px !important;\n    line-height: 1 !important;\n    margin: 0 !important;\n    padding-block: 0 !important;\n    color: #fff !important;\n}\n\n/* Unchecked state → only show \"Đầy đủ\" */\n.nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) .ant-switch-inner-unchecked {\n    display: inline-flex !important;\n}\n\n/* Checked state → only show \"Rút gọn\" */\n.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-inner-checked {\n    display: inline-flex !important;\n}\n\n.nagaco-simplify-switch.ant-switch .ant-switch-handle {\n    width: 20px;\n    height: 20px;\n    top: 3px;\n    inset-inline-start: 3px;\n}\n\n.nagaco-simplify-switch.ant-switch.ant-switch-checked .ant-switch-handle {\n    inset-inline-start: calc(100% - 23px);\n}\n\n.nagaco-simplify-switch.ant-switch .ant-switch-handle::before {\n    border-radius: 10px;\n}\n\nbody[data-theme='dark'] .nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) {\n    background: rgba(255, 255, 255, 0.2);\n}\n\nbody[data-theme='dark'] .nagaco-simplify-switch.ant-switch:not(.ant-switch-checked) .ant-switch-inner-unchecked {\n    color: #fff;\n}\n\nbody[data-theme='dark'] .nagaco-simplify-switch.ant-switch.ant-switch-checked {\n    background: rgba(255, 255, 255, 0.32);\n}\n\n/* Theme configurator — card layout matching design mock */\n\n.theme-configurator-drawer .ant-drawer-header {\n    padding: 14px 16px;\n    background: var(--theme-config-drawer-header-bg, #faf8f5);\n    border-bottom: 2px solid var(--theme-config-primary, #a00000);\n}\n\n.theme-configurator-drawer .ant-drawer-header-title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    gap: 12px;\n}\n\n.theme-configurator-drawer .ant-drawer-title {\n    flex: 1;\n    margin: 0;\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--theme-config-drawer-title, rgba(0, 0, 0, 0.88));\n    order: 1;\n}\n\n.theme-configurator-drawer__title {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.theme-configurator-drawer__chevron {\n    font-size: 11px;\n    color: var(--theme-config-primary, #a00000);\n}\n\n.theme-configurator-drawer .ant-drawer-close {\n    position: static;\n    order: 2;\n    margin-inline-start: auto;\n    inset: unset;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.theme-configurator-drawer .ant-drawer-close:hover {\n    background: transparent;\n}\n\n.theme-configurator-drawer__close-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 1px solid var(--theme-config-primary, #a00000);\n    background: var(--theme-config-primary-bg, #fff1f0);\n    color: var(--theme-config-primary, #a00000);\n    font-size: 12px;\n    line-height: 1;\n}\n\n.theme-configurator-drawer .ant-drawer-body {\n    padding: 0 !important;\n    background: var(--theme-config-drawer-bg, #f0f0f0);\n}\n\n.theme-configurator-drawer .ant-drawer-content {\n    background: var(--theme-config-drawer-bg, #f0f0f0);\n}\n\n.theme-configurator {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 12px var(--theme-config-card-gutter-x, 12px);\n}\n\n.theme-configurator .ant-main-card {\n    margin-bottom: 0;\n}\n\n.theme-configurator .ant-main-card .ant-card-body {\n    padding: var(--theme-config-card-body-inset, 12px) !important;\n}\n\n.theme-configurator__card {\n    background: var(--theme-config-drawer-surface, #fff);\n    border-radius: 16px;\n    overflow: hidden;\n    border-top: 3px solid var(--theme-config-primary, #a00000);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.theme-configurator__card-body {\n    margin: 0;\n}\n\n.theme-configurator__card-title {\n    margin: 0;\n    padding: 0 0 10px;\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--theme-config-label, rgba(0, 0, 0, 0.88));\n}\n\n.theme-configurator__option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    min-height: 48px;\n    padding: 10px 0;\n    border-top: 1px solid var(--theme-config-option-border, #f0f0f0);\n}\n\n.theme-configurator__option--danger {\n    background: var(--theme-config-danger-row-bg, var(--theme-config-primary-bg, #f5f5f5));\n    margin-inline: calc(-1 * var(--theme-config-card-body-inset, 12px));\n    padding-inline: var(--theme-config-card-body-inset, 12px);\n}\n\n.theme-configurator__option--disabled .theme-configurator__option-label,\n.theme-configurator__option--disabled .theme-configurator__option-control {\n    opacity: 0.35;\n    pointer-events: none;\n}\n\n.theme-configurator__option-label {\n    flex: 1;\n    min-width: 0;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.4;\n    color: var(--theme-config-label, rgba(0, 0, 0, 0.88));\n}\n\n.theme-configurator__option-control {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    max-width: 58%;\n}\n\n/* Pill segmented Radio.Group */\n.theme-configurator__segmented.ant-radio-group {\n    display: inline-flex;\n    background: #fff;\n    border: 1px solid #d9d9d9;\n    border-radius: 999px;\n    overflow: hidden;\n    padding: 0;\n}\n\n.theme-configurator__segmented .ant-radio-button-wrapper {\n    height: 30px;\n    line-height: 28px;\n    padding: 0 14px;\n    border: none !important;\n    border-radius: 0 !important;\n    background: transparent;\n    color: rgba(0, 0, 0, 0.65);\n    box-shadow: none !important;\n}\n\n.theme-configurator__segmented .ant-radio-button-wrapper::before {\n    display: none !important;\n}\n\n.theme-configurator__segmented .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background: var(--theme-config-primary, #a00000) !important;\n    color: #fff !important;\n}\n\n.theme-configurator__segmented .ant-radio-button-wrapper:hover {\n    color: var(--theme-config-primary, #a00000);\n}\n\n.theme-configurator__segmented .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n    color: #fff;\n}\n\n/* Theme select pill */\n.theme-configurator__pill.ant-select {\n    min-width: 130px;\n    max-width: 160px;\n}\n\n.theme-configurator__pill.ant-select .ant-select-selector {\n    height: 32px !important;\n    border-radius: 999px !important;\n    padding-inline: 12px !important;\n    align-items: center;\n}\n\n.theme-configurator__pill.ant-select .ant-select-selection-item,\n.theme-configurator__pill.ant-select .ant-select-selection-placeholder {\n    line-height: 30px !important;\n    display: flex;\n    align-items: center;\n}\n\n.theme-configurator__pill.ant-input-number {\n    width: 88px;\n    height: 32px;\n    border-radius: 999px;\n    overflow: hidden;\n}\n\n.theme-configurator__pill.ant-input-number .ant-input-number-input {\n    height: 30px;\n    text-align: center;\n}\n\n.theme-configurator__lang.ant-btn,\n.theme-configurator__lang {\n    height: 32px;\n    padding: 0 12px;\n    border-radius: 999px !important;\n    border: 1px solid #d9d9d9;\n    background: #fff;\n    display: inline-flex;\n    align-items: center;\n}\n\n.theme-configurator__delete {\n    font-size: 18px;\n    color: var(--ant-color-error, #ff4d4f);\n    cursor: pointer;\n    line-height: 1;\n}\n\n.theme-configurator__delete:hover {\n    opacity: 0.85;\n}\n\n.theme-configurator .color-picker .color-picker-dropdown {\n    border-radius: 8px;\n    padding: 3px;\n    border: 1px solid #d9d9d9;\n    background: #fff;\n}\n\n.theme-configurator .color-picker .color {\n    width: 48px;\n    height: 20px;\n    border-radius: 6px;\n    border: none;\n}\n\nbody[data-theme='dark'] .theme-configurator__option {\n    border-top-color: var(--ant-color-border, #303030);\n}\n\nbody[data-theme='dark'] .theme-configurator__option--danger {\n    background: var(--theme-config-drawer-surface, #262626);\n}\n\n/* System notification drawer */\n\n.nav-consumer-notification-drawer .ant-drawer-header {\n    padding: 12px 16px;\n    background: var(--nagaco-drawer-header-bg, var(--nagaco-drawer-primary-bg, #fcf8f2));\n    border-bottom: 2px solid var(--nagaco-drawer-primary, #a00000);\n}\n\n.nav-consumer-notification-drawer .ant-drawer-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--nagaco-drawer-title-color, rgba(0, 0, 0, 0.88));\n}\n\n.nav-consumer-notification-drawer__title {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.nav-consumer-notification-drawer__chevron {\n    font-size: 11px;\n    color: var(--nagaco-drawer-primary, #a00000);\n}\n\n.nav-consumer-notification-drawer__action-btn.ant-btn {\n    height: 28px;\n    padding: 0 14px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: rgba(0, 0, 0, 0.88) !important;\n    background: #fff !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.nav-consumer-notification-drawer__action-btn.ant-btn .anticon {\n    font-size: 10px;\n    color: inherit;\n}\n\n.nav-consumer-notification-drawer__action-btn.ant-btn:hover,\n.nav-consumer-notification-drawer__action-btn.ant-btn:focus {\n    color: rgba(0, 0, 0, 0.88) !important;\n    background: #fff !important;\n    border: none !important;\n    opacity: 0.92;\n}\n\n.nav-consumer-notification-drawer .ant-drawer-body {\n    padding: 12px 14px;\n    background: #f5f2ec;\n}\n\n.nav-consumer-notification-drawer .ant-drawer-footer {\n    padding: 12px 16px 16px;\n    background: #f5f2ec;\n    border-top: none;\n}\n\n.nagaco-drawer-extra {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.nagaco-drawer-extra__actions {\n    display: inline-flex;\n    align-items: center;\n}\n\n.nagaco-drawer-extra__zoom.ant-btn {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n}\n\n.nagaco-drawer-extra__close.ant-btn {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border-radius: 8px;\n}\n\n.nav-notification-actions-btn.ant-btn {\n    height: 32px;\n    border-radius: 999px;\n    padding-inline: 14px;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.nav-notification-wrapper {\n    height: 100%;\n}\n\n.nav-notification-body {\n    padding: 0 2px 8px;\n}\n\n.nav-notification-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: var(--nav-notification-list-gutter-top, 12px);\n    margin-inline: var(--nav-notification-list-gutter-x, 12px);\n}\n\n.nav-notification-card {\n    display: flex;\n    align-items: stretch;\n    gap: 10px;\n    padding: 12px 12px 12px 10px;\n    border-radius: 16px;\n    background: linear-gradient(90deg, #ffffff 0%, #fff8ef 100%);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    transition: box-shadow 0.2s ease;\n}\n\n.nav-notification-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.nav-notification-card.is-unread {\n    background: linear-gradient(90deg, #fff7f5 0%, #fff1e8 100%);\n}\n\n.nav-notification-card__icon {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1.5px solid var(--nagaco-drawer-primary, #a00000);\n    background: #fff;\n    color: var(--nagaco-drawer-primary, #a00000);\n    font-size: 18px;\n    margin-top: 2px;\n}\n\n.nav-notification-card.is-unread .nav-notification-card__icon {\n    background: var(--nagaco-drawer-primary, #a00000);\n    color: #fff;\n    border-color: var(--nagaco-drawer-primary, #a00000);\n}\n\n.nav-notification-card__main {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    cursor: pointer;\n}\n\n.nav-notification-card__title {\n    margin: 0;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1.45;\n    color: rgba(0, 0, 0, 0.88);\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.nav-notification-card.is-expanded .nav-notification-card__title {\n    display: block;\n    -webkit-line-clamp: unset;\n    overflow: visible;\n}\n\n.nav-notification-card__title a,\n.nav-notification-card__title strong,\n.nav-notification-card__title b,\n.nav-notification-card__title span[style*='color'] {\n    font-weight: 700;\n}\n\n.nav-notification-card__desc {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.45;\n    color: rgba(0, 0, 0, 0.55);\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.nav-notification-card.is-expanded .nav-notification-card__desc {\n    display: block;\n    -webkit-line-clamp: unset;\n    overflow: visible;\n}\n\n.nav-notification-card__toggle {\n    flex-shrink: 0;\n    align-self: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 1px solid #d9d9d9;\n    background: #fff;\n    color: rgba(0, 0, 0, 0.45);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 11px;\n    padding: 0;\n    transition: all 0.2s ease;\n}\n\n.nav-notification-card__toggle:hover {\n    border-color: var(--nagaco-drawer-primary, #a00000);\n    color: var(--nagaco-drawer-primary, #a00000);\n}\n\n.nav-notification-card.is-unread .nav-notification-card__toggle,\n.nav-notification-card.is-expanded .nav-notification-card__toggle {\n    background: var(--nagaco-drawer-primary, #a00000);\n    border-color: var(--nagaco-drawer-primary, #a00000);\n    color: #fff;\n}\n\n.nav-notification-card__toggle.is-open .anticon {\n    transform: rotate(180deg);\n}\n\n.nav-notification-card__divider {\n    width: 1px;\n    align-self: stretch;\n    margin: 4px 2px;\n    background: #e8e8e8;\n    flex-shrink: 0;\n}\n\n.nav-notification-card__meta {\n    flex-shrink: 0;\n    align-self: center;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 108px;\n}\n\n.nav-notification-card__meta-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #d4a017;\n    white-space: nowrap;\n}\n\n.nav-notification-card__meta-row .anticon {\n    font-size: 13px;\n    color: #e0b12a;\n}\n\n.nav-notification-card__more {\n    flex-shrink: 0;\n    align-self: center;\n}\n\n.nav-notification-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 40px 16px;\n    color: rgba(0, 0, 0, 0.45);\n}\n\n.nav-notification-footer {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.nav-notification-footer__btn.ant-btn {\n    min-width: 180px;\n    height: 40px;\n    border-radius: 999px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\nbody[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-header {\n    background: var(--nagaco-drawer-header-bg, #1f1f1f);\n}\n\nbody[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-body,\nbody[data-theme='dark'] .nav-consumer-notification-drawer .ant-drawer-footer {\n    background: var(--nagaco-drawer-body-bg, var(--ant-color-bg-layout, #141414));\n}\n\n.nav-consumer-notification-drawer .ant-drawer-body,\n.nav-consumer-notification-drawer .ant-drawer-footer {\n    background: var(--nagaco-drawer-body-bg, #f5f5f5);\n}\n\nbody[data-theme='dark'] .nav-notification-card {\n    background: linear-gradient(90deg, #1f1f1f 0%, #2a241c 100%);\n    border-color: #303030;\n}\n\nbody[data-theme='dark'] .nav-notification-card__title {\n    color: rgba(255, 255, 255, 0.88);\n}\n\nbody[data-theme='dark'] .nav-notification-card__desc {\n    color: rgba(255, 255, 255, 0.45);\n}\n\nbody[data-theme='dark'] .nav-notification-card__divider {\n    background: #303030;\n}\n\n/* Local storage notifications popover */\n\n.nav-local-notification-popover .ant-popover-inner {\n    padding: 0 !important;\n    overflow: hidden;\n    border-radius: 22px;\n    z-index: 1;\n    border: 1px solid var(--nav-noti-split, #d9e6ff);\n    border-top: 4px solid var(--nav-noti-primary, var(--ant-color-primary, #1677ff));\n    border-width: 3px 0 0 0;\n    box-shadow: 0 4px 16px rgba(51, 75, 196, 0.08);\n    background: var(--nav-noti-bg, #fff);\n}\n\n.nav-local-notification-popover .ant-popover-inner-content {\n    padding: 0 !important;\n}\n\n.nav-local-notification {\n    width: 340px;\n    max-width: min(340px, 92vw);\n    background: var(--nav-noti-bg, #fff);\n    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));\n}\n\n.nav-local-notification__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 14px;\n    border-bottom: 1px solid var(--nav-noti-split, #f0f0f0);\n}\n\n.nav-local-notification__title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));\n}\n\n.nav-local-notification__pill-btn.ant-btn {\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--nav-noti-pill-color, var(--nav-noti-primary, #1677ff)) !important;\n    border-color: var(\n        --nav-noti-pill-border-color,\n        var(--nav-noti-primary-border, var(--nav-noti-primary, #1677ff))\n    ) !important;\n    background: transparent !important;\n    box-shadow: none !important;\n}\n\n.nav-local-notification__pill-btn.ant-btn:hover,\n.nav-local-notification__pill-btn.ant-btn:focus {\n    color: var(--nav-noti-pill-hover-color, #fff) !important;\n    background: var(--nav-noti-pill-hover-bg, var(--nav-noti-primary, #1677ff)) !important;\n    border-color: var(\n        --nav-noti-pill-hover-border,\n        var(--nav-noti-primary, #1677ff)\n    ) !important;\n}\n\n.nav-local-notification__body {\n    max-height: 360px;\n    overflow: auto;\n}\n\n.nav-local-notification__list.ant-list .ant-list-item.nav-local-notification__item {\n    padding: 0;\n    margin: 0;\n    border: none !important;\n}\n\n.nav-local-notification__item-inner {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    width: 100%;\n    padding: 12px 14px;\n    border-bottom: 1px solid var(--nav-noti-split, #e8e8e8);\n}\n\n.nav-local-notification__list.ant-list .ant-list-item.nav-local-notification__item:last-child .nav-local-notification__item-inner {\n    border-bottom: none;\n}\n\n.nav-local-notification__avatar {\n    flex-shrink: 0;\n}\n\n.nav-local-notification__avatar .ant-avatar,\n.nav-local-notification__avatar-icon.ant-avatar {\n    width: 36px;\n    height: 36px;\n    line-height: 36px;\n    background: var(--nav-noti-error-bg, #fff1f0);\n    color: var(--nav-noti-error, #ff4d4f);\n}\n\n.nav-local-notification__avatar-icon.ant-avatar-success {\n    background: var(--ant-color-success-bg, #f6ffed);\n    color: var(--ant-color-success, #52c41a);\n}\n\n.nav-local-notification__avatar-icon.ant-avatar-info {\n    background: var(--nav-noti-primary-bg, #e6f4ff);\n    color: var(--nav-noti-primary, #1677ff);\n}\n\n.nav-local-notification__content {\n    flex: 1;\n    min-width: 0;\n}\n\n.nav-local-notification__desc {\n    font-size: 13px;\n    line-height: 1.45;\n    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));\n}\n\n.nav-local-notification__name {\n    margin-top: 2px;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1.4;\n    text-transform: uppercase;\n    color: var(--nav-noti-text, rgba(0, 0, 0, 0.88));\n    word-break: break-word;\n}\n\n.nav-local-notification__meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.nav-local-notification__time {\n    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.nav-local-notification__footer {\n    padding: 12px 14px;\n    text-align: center;\n    background: var(--nav-noti-footer-bg, #faf5ef);\n    border-top: 1px solid var(--nav-noti-split, #f0f0f0);\n}\n\n.nav-local-notification__footer-link {\n    color: var(--nav-noti-footer-link, var(--nav-noti-primary, #a00000));\n    font-weight: 600;\n    font-size: 13px;\n    text-decoration: none;\n}\n\n.nav-local-notification__footer-link:hover {\n    color: var(--nav-noti-primary, #a00000);\n    text-decoration: underline;\n}\n\n.nav-local-notification__empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 28px 16px;\n    color: var(--nav-noti-text-secondary, rgba(0, 0, 0, 0.45));\n}\n\nbody[data-theme='dark'] .nav-local-notification-popover .ant-popover-inner {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n}\n\n.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {\n    display: block !important;\n}\n\n.nagaco-date-range-picker-popup .ant-picker-cell-inner {\n    border-radius: 50% !important;\n}\n\n.nagaco-date-range-picker-popup .ant-picker-cell-range-start .ant-picker-cell-inner,\n.nagaco-date-range-picker-popup .ant-picker-cell-range-end .ant-picker-cell-inner {\n    border-radius: 50% !important;\n}\n\n.nagaco-date-range-picker-popup .ant-picker-cell-today .ant-picker-cell-inner::before {\n    border-radius: 50% !important;\n}\n.table-wrapper-mf, .table-wrapper{\n\tborder-radius: 16px 16px 0 0;\n}\n.ant-drawer .ant-drawer-body \n{\n    padding: 0px !important;\n}\n\n.nagaco-custom-drawer .ant-drawer-title {\n    color: var(--nagaco-drawer-title-color, inherit);\n}\n\n.nagaco-custom-drawer .ant-drawer-header {\n    background: var(--nagaco-drawer-header-bg, inherit);\n}\n\n.nagaco-custom-drawer .ant-drawer-body {\n    background: var(--nagaco-drawer-body-bg, inherit);\n    color: var(--nagaco-drawer-text-color, inherit);\n}\n\n.nagaco-custom-drawer .ant-drawer-footer {\n    background: var(--nagaco-drawer-footer-bg, var(--nagaco-drawer-body-bg, inherit));\n}\n\n.line-clamp-2 {\n    /* background-color: gray; */\n    /* margin-left: -20px; */\n    padding: 15px 20px;\n    width: calc(100% + 40px);\n    /* background: #BFBFBF; */\n    border-top: solid 1px #BFBFBF;\n    border-bottom: solid 1px #BFBFBF;\n    background: linear-gradient(0deg,rgba(191, 191, 191, 1) 0%, rgba(255, 255, 255, 1) 100%);\n}\n\n.statistic-item + .statistic-item {\n    border-top: solid 1px #BFBFBF;\n\n}\n\n.bom-modal-root, \n.nagaco-overlay-root {\n    \n    z-index: 1000 !important;\n}\n\n.national-day-branch-left{ \n    /* left: 175px  */\n    margin-left: 10px;\n}\n\n.label-warning {\n    color: #B85814 !important;\n}\n\n.label-success {\n    color: #2D8643 !important;\n}\n\n.label-danger {\n    color: #CF0505 !important;\n}\n\n/* .popup-drawer {\n    z-index: 2200 !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
